(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __esm = (fn, res, err) => function __init() {
    if (err) throw err[0];
    try {
      return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
    } catch (e) {
      throw err = [e], e;
    }
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };

  // personalisation-product-integration/personalised-fields.mjs
  function normaliseFields(handle, input, { supports = () => true } = {}) {
    const schema = FIELD_SCHEMAS[handle];
    if (!schema || !input || typeof input !== "object" || Array.isArray(input)) throw Error("Choose a valid print design.");
    for (const key of Object.keys(input)) if (!schema.some((f) => f.key === key)) throw Error("Unexpected personalisation field.");
    const values = {};
    for (const f of schema) {
      let v = input[f.key];
      if (f.key === "timeZone" && v == null) v = "";
      if (typeof v !== "string") throw Error("Please complete " + f.label + ".");
      v = v.normalize("NFC").trim();
      if (!v && f.optional) {
        values[f.key] = "";
        continue;
      }
      if (!v) throw Error("Please complete " + f.label + ".");
      if (f.type === "text") {
        v = v.replace(/\s+/g, " ");
        if ([...v].length > f.max || /[\u0000-\u001f\u007f]/.test(v)) throw Error(f.label + " must use up to " + f.max + " characters.");
      }
      if (f.type === "lines") {
        const lines = v.split(/\r?\n/).map((x) => x.trim()).filter(Boolean);
        if (lines.length < 1 || lines.length > f.max || lines.some((s) => [...s].length > f.lineMax)) throw Error("Use one to " + f.max + " lines, each up to " + f.lineMax + " characters.");
        v = lines.join("\n");
      }
      if (f.type === "date") {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(v) || !Number.isFinite(Date.parse(v + "T12:00:00Z")) || (/* @__PURE__ */ new Date(v + "T12:00:00Z")).toISOString().slice(0, 10) !== v || +v.slice(0, 4) < 1900 || +v.slice(0, 4) > 2100) throw Error("Choose a real date between 1900 and 2100.");
      }
      if (f.type === "year" && !/^(19|20)\d{2}$/.test(v)) throw Error("Use a four-digit year from 1900 to 2099.");
      if (f.type === "time" && !/^([01]\d|2[0-3]):[0-5]\d$/.test(v)) throw Error("Enter a valid time.");
      if (f.type === "timezone") {
        try {
          new Intl.DateTimeFormat("en", { timeZone: v }).format();
        } catch {
          throw Error("Choose a valid location and time zone.");
        }
      }
      const ranges = { latitude: [-90, 90], longitude: [-180, 180], offset: [-12, 14] };
      if (ranges[f.type]) {
        const [min, max] = ranges[f.type];
        if (!/^-?\d+(\.\d+)?$/.test(v) || +v < min || +v > max || f.type === "offset" && +v * 4 % 1) throw Error("Enter a valid " + f.label + ".");
        v = String(+v);
      }
      if (f.type === "select" && !f.options.some((o) => o[0] === v)) throw Error("Choose a listed colour.");
      if (["text", "lines"].includes(f.type) && ![...v.replaceAll("\n", "")].every(supports)) throw Error("This text contains a character our print fonts do not support.");
      values[f.key] = v;
    }
    return values;
  }
  var t, d, year, colour, location2, FIELD_SCHEMAS, DESIGN_DEFAULTS;
  var init_personalised_fields = __esm({
    "personalisation-product-integration/personalised-fields.mjs"() {
      t = (key, label, value, max = 70, optional = false) => ({ key, label, value, max, optional, type: "text" });
      d = (key, label, value) => ({ key, label, value, type: "date" });
      year = (value = "1998") => ({ key: "year", label: "Established year", value, type: "year" });
      colour = { key: "palette", label: "Colour palette", type: "select", value: "original", options: [["original", "Original colours"], ["sage", "Sage"], ["rose", "Dusty rose"], ["blue", "Soft blue"]] };
      location2 = [t("location", "Location label", "Copenhagen, Denmark", 90), { key: "latitude", label: "Latitude", type: "latitude", value: "55.6761" }, { key: "longitude", label: "Longitude", type: "longitude", value: "12.5683" }];
      FIELD_SCHEMAS = {
        "personalized-family-poster": [t("family", "Family heading", "THE ROBERTS FAMILY"), t("names", "Family names", "Robert \xB7 Julie \xB7 Sam \xB7 George", 110), year("1997"), colour],
        "abstract-figures": [t("eyebrow", "Small heading", "A LITTLE LOVE, EVERY DAY", 60), t("heading", "Main heading", "You & me.", 40), t("names", "Names", "ELLA & DAVID", 65), colour],
        "no-place-like-home-print": [t("family", "Family name", "THE DERBYSHIRE FAMILY"), year(), t("address", "Address", "121 Chadworth Street", 90), t("location", "Town or city", "LONDON", 80), colour],
        "custom-song-wall-art": [t("eyebrow", "Small heading", "THE SOUNDTRACK TO US", 60), t("heading", "Main heading", "On repeat.", 35), ...["One Dance - Drake", "Unforgettable - French Montana", "Sorry - Justin Bieber", "One Kiss - Calvin Harris", "Hello - Adele", "Rockstar - Post Malone", "God\u2019s Plan - Drake", "Bohemian Rhapsody - Queen", "7 Years - Lukas Graham", "Summer of \u201969 - Bryan Adams"].map((s, i) => t("song" + (i + 1), "Song " + (i + 1) + " \xB7 title and artist", s, 85)), t("subtitle", "Bottom line", "MY FAVOURITE SONGS \xB7 OF ALL TIME", 75), colour],
        "custom-quote-poster": [t("name", "Name", "Caroline", 40), { key: "affirmations", label: "Affirmations \xB7 one per line", value: ["grounded", "fearless", "valued", "wise", "resilient", "deserving", "whole", "growing", "unstoppable"].map((s) => "I am " + s + ".").join("\n"), type: "lines", max: 9, lineMax: 55 }, colour],
        "personalised-baby-poster": [t("name", "Baby\u2019s name", "George", 40), d("date", "Birth date", "2025-11-18"), colour],
        "love-map-poster": [...location2, t("heading", "Heading", "OUR FAVOURITE PLACE", 60), t("names", "Names", "Leonardo & Maria", 65), d("date", "Date", "2024-12-12"), colour],
        "born-this-day-custom": [t("name", "Baby\u2019s name", "Adam Jenkins", 65), d("date", "Birth date", "2025-12-06"), t("weight", "Weight", "4,310 g", 22, true), t("length", "Length", "45 cm", 22, true), { key: "time", label: "Birth time", type: "time", value: "03:34", optional: true }, colour],
        "home-beige-personal-print": [t("family", "Family name", "The Anderson family", 70), year(), colour],
        "custom-star-map": [t("heading", "Heading", "WHERE IT ALL BEGAN", 65), t("subtitle", "Personal message", "The night our story began", 85, true), t("location", "Location label", "Miami, Florida", 90), { key: "latitude", label: "Latitude", type: "latitude", value: "25.7617" }, { key: "longitude", label: "Longitude", type: "longitude", value: "-80.1918" }, d("date", "Date", "2018-11-23"), { key: "time", label: "Local time", type: "time", value: "21:00" }, { key: "utcOffset", label: "UTC offset at that date \xB7 hours", type: "offset", value: "-5" }, { key: "timeZone", label: "Time zone", type: "timezone", value: "America/New_York", optional: true }],
        "heart-on-map-print": [...location2, t("heading", "Heading", "WHERE IT ALL BEGAN", 60), t("names", "Names", "Will & Catherine", 65), colour],
        "personalised-quote-poster": [t("quote", "Main words", "dream.", 180), t("subtitle", "Smaller line", "Everything is possible.", 140, true), colour],
        "custom-anniversary-gift": [...location2, t("heading", "Heading", "Copenhagen", 60), t("subtitle", "Personal message", "HOME IS WHERE THE HEART IS", 85), d("date", "Date", "1998-11-04"), colour],
        "personalized-anniversary-gift": [t("heading", "Heading", "FROM THIS DAY FORWARD", 60), d("date", "Anniversary date", "2025-06-08"), t("names", "Names", "Annabel & Mark", 65), colour],
        "street-name-family-personal": [t("street", "Street name", "ST ANDREWS", 65), t("suffix", "Street type", "ROAD", 30), t("number", "House number", "121", 20), t("eyebrow", "Small heading", "OUR STREET, OUR STORY", 60), colour]
      };
      DESIGN_DEFAULTS = Object.fromEntries(Object.entries(FIELD_SCHEMAS).map(([handle, fields]) => [handle, Object.fromEntries(fields.map((f) => [f.key, f.value]))]));
    }
  });

  // personalisation-product-integration/personalised-scene.mjs
  function circlePath(x, y, r) {
    const k = 0.552284749831 * r;
    return `M${x + r} ${y}C${x + r} ${y + k} ${x + k} ${y + r} ${x} ${y + r}C${x - k} ${y + r} ${x - r} ${y + k} ${x - r} ${y}C${x - r} ${y - k} ${x - k} ${y - r} ${x} ${y - r}C${x + k} ${y - r} ${x + r} ${y - k} ${x + r} ${y}Z`;
  }
  function transform(s = "") {
    let m = identity;
    for (const p of s.matchAll(/(translate|rotate|scale|matrix)\(([^)]+)\)/g)) {
      const v = p[2].trim().split(/[ ,]+/).map(Number);
      let n;
      if (p[1] === "translate") n = [1, 0, 0, 1, v[0], v[1] || 0];
      if (p[1] === "scale") n = [v[0], 0, 0, v[1] ?? v[0], 0, 0];
      if (p[1] === "matrix") n = v;
      if (p[1] === "rotate") {
        const a = v[0] * Math.PI / 180, c = Math.cos(a), s2 = Math.sin(a);
        n = [c, s2, -s2, c, 0, 0];
        if (v.length === 3) n = mul(mul([1, 0, 0, 1, v[1], v[2]], n), [1, 0, 0, 1, -v[1], -v[2]]);
      }
      m = mul(m, n);
    }
    return m;
  }
  function buildPersonalisedScene(product, input, mm, resources, { sky = null, map = null, allowMapPlaceholder = false } = {}) {
    if (!Array.isArray(mm) || mm.length !== 2 || mm.some((n) => !Number.isFinite(n) || n <= 0)) throw Error("Invalid print dimensions.");
    const fontData = resources.fonts, values = normaliseFields(product.handle, input, { supports: (c) => Object.values(fontData).every((f) => f.glyphs[c]) });
    const W = 750, H = W * mm[1] / mm[0], Y = (n) => n * H / 1e3, nodes = [], textBoxes = [];
    const original = { ink: "#292823", cream: "#f4f0e7", accent: "#778072", secondary: "#a05f49" };
    const palette = { original, sage: { ...original, cream: "#edf0e8", accent: "#64765d", secondary: "#65765e" }, rose: { ...original, cream: "#f4e9e5", accent: "#9b6e70", secondary: "#a05f64" }, blue: { ...original, cream: "#eaf0f2", accent: "#536f83", secondary: "#536f83" } }[values.palette || "original"];
    let background = palette.cream;
    const { ink, accent, secondary } = palette;
    const path = (d2, fill = ink, { matrix = identity, stroke, strokeWidth = 1, opacity = 1, clipPolygon } = {}) => nodes.push({ d: d2, fill, matrix, stroke, strokeWidth, opacity, ...clipPolygon ? { clipPolygon } : {} });
    const rect = (x, y, w, h2, fill, stroke, strokeWidth = 1) => path(`M${x} ${y}h${w}v${h2}h${-w}Z`, fill, { stroke, strokeWidth });
    const line = (y, color = "#cfc9bf", x1 = 75, x2 = 675) => path(`M${x1} ${y}H${x2}`, null, { stroke: color, strokeWidth: 1.3 });
    const width = (s, size, font = "serif") => {
      const f = fontData[font];
      let w = 0;
      for (let i = 0; i < s.length; i++) w += (f.glyphs[s[i]]?.advance || 0) + (i ? f.kern[s[i - 1] + s[i]] || 0 : 0);
      return w * size / 1e3;
    };
    function text(s, x, y, size = 28, { font = "serif", fill = ink, align = "center", max = 640 } = {}) {
      s = String(s);
      const f = fontData[font], z = Math.min(size, size * max / Math.max(1e-3, width(s, size, font))), w = width(s, z, font), start = align === "left" ? x : align === "right" ? x - w : x - w / 2;
      let pen = 0;
      for (let i = 0; i < s.length; i++) {
        const c = s[i], g = f.glyphs[c];
        if (!g) throw Error("Unsupported print character.");
        if (i) pen += f.kern[s[i - 1] + c] || 0;
        if (g.d) path(g.d, fill, { matrix: [z / 1e3, 0, 0, z / 1e3, start + pen * z / 1e3, y] });
        pen += g.advance;
      }
      textBoxes.push({ text: s, x: start, y: y - z, width: w, height: z * 1.3, fontSize: z });
    }
    const label = (s, y, fill = ink, x = 375) => text(s.toUpperCase(), x, y, 14, { font: "sans", fill });
    function illustration(name, x, y, w, h2) {
      const a = resources.illustrations[name], s = Math.min(w / a.box[2], h2 / a.box[3]), m = [s, 0, 0, s, x + (w - a.box[2] * s) / 2, y + (h2 - a.box[3] * s) / 2];
      for (const n of a.nodes) path(n.type === "circle" ? circlePath(n.cx, n.cy, n.r) : n.d, n.fill, { matrix: mul(m, transform(n.transform)), stroke: n.stroke, strokeWidth: n.strokeWidth });
    }
    const date = values.date ? /* @__PURE__ */ new Date(values.date + "T12:00:00Z") : null;
    const dateLabel = date?.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
    const h = product.handle;
    function streetMap(x, y, w, height, clipPolygon) {
      if (!map?.verified || map.format !== "vector" || !Array.isArray(map.layers) || map.latitude !== +values.latitude || map.longitude !== +values.longitude) throw Error("Verified vector geometry for the selected location is required.");
      rect(x, y, w, height, values.palette === "original" ? "#e7e2d8" : palette.cream);
      const styles = { park: { fill: values.palette === "original" ? "#c7ccb9" : accent }, building: { fill: values.palette === "original" ? "#dbd5c9" : "#dbd8d0" }, water: { fill: values.palette === "original" ? "#afbdc0" : "#b1c1c6" }, waterway: { stroke: "#a6b8bd", strokeWidth: 1.8 }, railway: { stroke: "#aaa69d", strokeWidth: 0.55 }, path: { stroke: "#f9f6ef", strokeWidth: 1.1 }, "minor-road": { stroke: "#fffdf6", strokeWidth: 2.1 }, "major-road": { stroke: "#fdf9ef", strokeWidth: 3.7 } };
      const side = Math.max(w, height), matrix = [side / 1e3, 0, 0, side / 1e3, x + (w - side) / 2, y + (height - side) / 2];
      for (const layer of map.layers) {
        const style = styles[layer.kind];
        if (!style) continue;
        path(layer.d, style.fill || null, { matrix, ...style, clipPolygon });
      }
    }
    if (h === "personalized-family-poster") {
      label(values.family, Y(142), values.palette === "original" ? ink : accent);
      text("Every family", 375, Y(350), 73);
      text("has a story.", 375, Y(440), 82, { font: "italic" });
      line(Y(536));
      text("Welcome to ours.", 375, Y(610), 38);
      text(values.names, 375, Y(815), 25);
      label("SINCE " + values.year, Y(855), values.palette === "original" ? ink : accent);
    } else if (h === "abstract-figures") {
      label(values.eyebrow, Y(100), accent);
      illustration("couple", 110, Y(165), 530, Y(570));
      text(values.heading, 375, Y(810), 54, { font: "italic" });
      label(values.names, Y(875));
    } else if (h === "no-place-like-home-print") {
      background = values.palette === "original" ? "#f0ebdf" : background;
      label(values.family, Y(80), accent);
      label("SINCE " + values.year, Y(115), accent);
      ["THERE", "IS NO", "PLACE", "LIKE", "HOME"].forEach((s, i) => text(s, 375, Y(330 + i * 106), 104, { fill: accent, max: 615 }));
      label(values.address, Y(900), accent);
      label(values.location, Y(935), accent);
    } else if (h === "custom-song-wall-art") {
      background = values.palette === "original" ? "#213e4a" : values.palette === "rose" ? "#663f49" : values.palette === "sage" ? "#3c5044" : "#254659";
      label(values.eyebrow, Y(102), "#e0cbb0");
      text(values.heading, 75, Y(215), 74, { font: "italic", fill: "#fff8ee", align: "left" });
      for (let i = 0; i < 10; i++) {
        text(String(i + 1).padStart(2, "0"), 78, Y(320 + i * 50), 16, { font: "sans", fill: "#d8bda2", align: "left" });
        text(values["song" + (i + 1)], 130, Y(320 + i * 50), 23, { font: "sans", fill: "#fff8ee", align: "left", max: 545 });
        line(Y(338 + i * 50), "#526b73");
      }
      label(values.subtitle, Y(910), "#e0cbb0");
    } else if (h === "custom-quote-poster") {
      label("A NOTE TO MYSELF", Y(105), accent);
      const lines = values.affirmations.split("\n"), gap = Math.min(69, 560 / Math.max(1, lines.length - 1)), top = 228 + (9 - lines.length) * gap / 3;
      lines.forEach((s, i) => text(s, 78, Y(top + i * gap), 39, { fill: i % 3 === 0 ? accent : ink, align: "left", max: 595 }));
      line(Y(810));
      text(values.name, 75, Y(893), 55, { font: "italic", align: "left", fill: secondary, max: 600 });
    } else if (h === "personalised-baby-poster") {
      if (values.palette === "original") background = "#f6f0e8";
      label("A LITTLE WONDER", Y(100), accent);
      illustration("mobile", 200, Y(150), 350, Y(420));
      text("Hello, " + values.name + ".", 375, Y(712), 62, { font: "italic" });
      line(Y(775), "#d7c7b7", 225, 525);
      text(dateLabel, 375, Y(838), 26);
      label("SO SMALL. SO LOVED.", Y(900), accent);
    } else if (h === "born-this-day-custom") {
      label("THE DAY YOU ARRIVED", Y(100), accent);
      text(values.date.slice(8), 375, Y(425), 260);
      text(date.toLocaleDateString("en-GB", { month: "long", timeZone: "UTC" }), 375, Y(515), 66, { font: "italic" });
      label(date.toLocaleDateString("en-GB", { weekday: "long", timeZone: "UTC" }) + " \xB7 " + values.date.slice(0, 4), Y(570), accent);
      line(Y(655));
      text(values.name, 375, Y(762), 43);
      label([values.weight, values.length, values.time].filter(Boolean).join(" \xB7 "), Y(842), accent);
    } else if (h === "home-beige-personal-print") {
      label("A PLACE TO BELONG", Y(143), values.palette === "original" ? ink : accent);
      text("H O M E", 375, Y(460), 125, { fill: values.palette === "original" ? "#9a9186" : accent, max: 650 });
      text("is wherever we are.", 375, Y(548), 38, { font: "italic" });
      line(Y(660));
      text(values.family, 375, Y(805), 31);
      label("SINCE " + values.year, Y(850), values.palette === "original" ? ink : accent);
    } else if (h === "personalised-quote-poster") {
      let wrap = function(z) {
        const result = [];
        let current = "";
        for (const word of values.quote.split(/\s+/)) {
          if (current && width(current + " " + word, z, "italic") > 610) {
            result.push(current);
            current = "";
          }
          if (width(word, z, "italic") > 610) {
            for (const ch of word) {
              if (current && width(current + ch, z, "italic") > 610) {
                result.push(current);
                current = "";
              }
              current += ch;
            }
          } else current += (current ? " " : "") + word;
        }
        if (current) result.push(current);
        return result;
      };
      let size = values.quote.length < 15 ? 132 : values.quote.length < 70 ? 78 : 55, lines = [];
      for (let attempt = 0; attempt < 25; attempt++) {
        lines = wrap(size);
        if (lines.length <= 6 && lines.length * size * 1.25 <= 420) break;
        size *= 0.9;
      }
      if (lines.length > 6 || size < 18) throw Error("Please shorten the main words for this layout.");
      const centre = Y(475), gap = size * 1.25;
      lines.forEach((s, i) => text(s, 375, centre + (i - (lines.length - 1) / 2) * gap, size, { font: "italic", max: 610 }));
      text(values.subtitle, 375, Math.max(Y(660), centre + (lines.length - 1) / 2 * gap + size * 1.6), 26, { font: "sans", fill: accent, max: 630 });
    } else if (h === "personalized-anniversary-gift") {
      background = values.palette === "original" ? "#d5c7b6" : values.palette === "sage" ? "#9ca590" : values.palette === "rose" ? "#bf9b95" : "#95a6b4";
      rect(27, 27, 696, H - 54, background, "#fffef9", 16);
      label(values.heading, Y(100), "#ffffff");
      [values.date.slice(8), values.date.slice(5, 7), values.date.slice(2, 4)].forEach((s, i) => text(s, 375, Y(380 + i * 215), 245, { fill: "#fffef9" }));
      label(values.names, Y(915), "#ffffff");
    } else if (h === "street-name-family-personal") {
      background = "#fbfaf6";
      rect(68, Y(68), 614, Y(864), "#fbfaf6");
      rect(68, Y(68), 614, Y(237), values.palette === "original" ? "#e6bdb4" : values.palette === "sage" ? "#c9d3bd" : values.palette === "rose" ? "#ddb2b3" : "#bbcddd");
      rect(68, Y(68), 614, Y(864), null, ink, 5);
      line(Y(305), ink, 68, 682);
      label(values.eyebrow, Y(173));
      text(values.street, 375, Y(480), 50, { font: "sans", max: 555 });
      text(values.suffix, 375, Y(547), 50, { font: "sans" });
      text("No. " + values.number, 375, Y(787), 56, { font: "italic" });
      label("A PLACE TO CALL HOME", Y(868), accent);
    } else if (h === "custom-star-map") {
      if (!sky) throw Error("Accurate sky data is required before preparing this print.");
      background = "#080909";
      rect(27, 27, 696, H - 54, null, "#f8f8f6", 2);
      label(values.heading, Y(150), "#ffffff");
      const r = Math.min(292, H * 0.285), cx = 375, cy = Y(500), horizonClip = Array.from({ length: 720 }, (_, i) => [cx + r * Math.cos(i * Math.PI / 360), cy + r * Math.sin(i * Math.PI / 360)]);
      for (const n of sky.nodes) path(n.d, n.fill, { matrix: [r, 0, 0, r, cx, cy], stroke: n.stroke, strokeWidth: n.strokeWidth, ...n.clipHorizon ? { clipPolygon: horizonClip } : {} });
      path(circlePath(cx, cy, r), null, { stroke: "#d9dcd8", strokeWidth: 1.3 });
      text(values.subtitle, 375, Y(825), 23, { font: "italic", fill: "#f7f6f0" });
      label(dateLabel, Y(875), "#fff");
      label(values.location, Y(909), "#d3d9d5");
      text(values.time + " \xB7 UTC" + (+values.utcOffset >= 0 ? "+" : "") + values.utcOffset, 375, Y(939), 11, { font: "sans", fill: "#a5aaa6" });
    } else if (product.needsMapService) {
      if (!map?.verified && !allowMapPlaceholder) throw Error("MAP_SERVICE_REQUIRED");
      const fill = "#e4dfd6";
      if (h === "love-map-poster") {
        label(values.heading, Y(136), accent);
        const heart = `M375 ${Y(635)}C335 ${Y(605)} 170 ${Y(495)} 170 ${Y(380)}C170 ${Y(270)} 315 ${Y(240)} 375 ${Y(335)}C435 ${Y(240)} 580 ${Y(270)} 580 ${Y(380)}C580 ${Y(495)} 415 ${Y(605)} 375 ${Y(635)}Z`;
        if (map?.verified) {
          const segments = [[[375, Y(635)], [335, Y(605)], [170, Y(495)], [170, Y(380)]], [[170, Y(380)], [170, Y(270)], [315, Y(240)], [375, Y(335)]], [[375, Y(335)], [435, Y(240)], [580, Y(270)], [580, Y(380)]], [[580, Y(380)], [580, Y(495)], [415, Y(605)], [375, Y(635)]]], clip = [];
          for (const points of segments) for (let i = 0; i < 128; i++) {
            const t2 = i / 128, u = 1 - t2;
            clip.push([0, 1].map((k) => u * u * u * points[0][k] + 3 * u * u * t2 * points[1][k] + 3 * u * t2 * t2 * points[2][k] + t2 * t2 * t2 * points[3][k]));
          }
          const before = nodes.length;
          streetMap(170, Y(260), 410, Y(375), clip);
          nodes[before].clipPolygon = clip;
          const pinY = Y(447.5);
          path(`M375 ${pinY + 15}C363 ${pinY + 6} 359 ${pinY + 1} 363 ${pinY - 6}C366 ${pinY - 12} 373 ${pinY - 10} 375 ${pinY - 5}C377 ${pinY - 10} 384 ${pinY - 12} 387 ${pinY - 6}C391 ${pinY + 1} 387 ${pinY + 6} 375 ${pinY + 15}Z`, secondary);
          label(values.location, Y(710), accent);
        } else {
          path(heart, fill);
          label("MAP CONNECTION PENDING", Y(430), accent);
          text(values.location, 375, Y(470), 19, { font: "sans", fill: accent, max: 350 });
        }
        text(values.names, 375, Y(788), 43, { font: "italic" });
        label(dateLabel, Y(848), accent);
      } else if (h === "heart-on-map-print") {
        label(values.heading, Y(107), accent);
        rect(85, Y(182), 580, Y(530), fill);
        if (map?.verified) {
          streetMap(85, Y(182), 580, Y(530), [[85, Y(182)], [665, Y(182)], [665, Y(712)], [85, Y(712)]]);
        } else {
          label("MAP CONNECTION PENDING", Y(435), accent);
          text(values.location, 375, Y(480), 23, { font: "sans", fill: accent, max: 530 });
        }
        text(values.names, 375, Y(822), 44, { font: "italic" });
        label(values.location, Y(880), accent);
      } else {
        text(values.heading, 375, Y(142), 56, { font: "italic" });
        rect(85, Y(205), 580, Y(510), fill);
        if (map?.verified) {
          streetMap(85, Y(205), 580, Y(510), [[85, Y(205)], [665, Y(205)], [665, Y(715)], [85, Y(715)]]);
        } else {
          label("MAP CONNECTION PENDING", Y(435), accent);
          text(values.location, 375, Y(480), 23, { font: "sans", fill: accent, max: 530 });
        }
        label(values.subtitle, Y(800), accent);
        text(dateLabel, 375, Y(869), 29);
      }
    } else throw Error("Unknown print design.");
    return { width: W, height: H, mm, background, nodes, values, textBoxes, engine: "personalised-v1", revision: 1, attribution: sky?.attribution || map?.attribution || null };
  }
  var identity, mul;
  var init_personalised_scene = __esm({
    "personalisation-product-integration/personalised-scene.mjs"() {
      init_personalised_fields();
      identity = [1, 0, 0, 1, 0, 0];
      mul = (a, b) => [a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1], a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3], a[0] * b[4] + a[2] * b[5] + a[4], a[1] * b[4] + a[3] * b[5] + a[5]];
    }
  });

  // personalisation-product-integration/personalised-sky.mjs
  var personalised_sky_exports = {};
  __export(personalised_sky_exports, {
    buildSky: () => buildSky
  });
  function buildSky(values, data, A) {
    const utc = new Date(Date.parse(values.date + "T" + values.time + ":00Z") - Number(values.utcOffset) * 36e5);
    if (!Number.isFinite(utc.getTime())) throw Error("Enter a valid date, time and UTC offset.");
    const observer = new A.Observer(+values.latitude, +values.longitude, 0), rotation = A.Rotation_EQJ_HOR(utc, observer), years = (utc.getTime() - Date.UTC(2e3, 0, 1, 12)) / 315576e5;
    function horizontal(ra, dec) {
      const v = A.VectorFromSphere(new A.Spherical(dec, ra * 15, 1), utc), h = A.HorizonFromVector(A.RotateVector(rotation, v), "");
      return { altitude: h.lat, azimuth: h.lon };
    }
    function project(ra, dec) {
      const h = horizontal(ra, dec);
      if (h.altitude < 0) return null;
      const r = Math.tan((90 - h.altitude) * Math.PI / 360), az = h.azimuth * Math.PI / 180;
      return { x: -r * Math.sin(az), y: -r * Math.cos(az), altitude: h.altitude, azimuth: h.azimuth };
    }
    const visible = /* @__PURE__ */ new Map(), all = /* @__PURE__ */ new Map(), nodes = [];
    for (const [hip, ra, dec, mag, pmra, pmdec] of data.stars) {
      const cos = Math.cos(dec * Math.PI / 180), r = ra + (Math.abs(cos) > 1e-3 ? pmra * years / 36e5 / cos / 15 : 0), d2 = dec + pmdec * years / 36e5, p = project(r, d2);
      all.set(hip, { ra: r, dec: d2 });
      if (p) {
        visible.set(hip, { ...p, mag });
      }
    }
    const line = (points, color, width) => {
      let d2 = "", last = false;
      for (const p of points) {
        if (!p) {
          last = false;
          continue;
        }
        d2 += (last ? "L" : "M") + p.x.toFixed(6) + " " + p.y.toFixed(6);
        last = true;
      }
      if (d2) nodes.push({ d: d2, fill: null, stroke: color, strokeWidth: width });
    };
    for (let dec = -60; dec <= 60; dec += 30) line(Array.from({ length: 361 }, (_, i) => project(i / 15, dec)), "#434f48", 14e-4);
    for (let ra = 0; ra < 24; ra += 2) line(Array.from({ length: 181 }, (_, i) => project(ra, i - 90)), "#434f48", 14e-4);
    for (const poly of data.lines) for (let i = 1; i < poly.length; i++) {
      const a = all.get(poly[i - 1]), b = all.get(poly[i]);
      if (!a || !b) continue;
      const v1 = A.VectorFromSphere(new A.Spherical(a.dec, a.ra * 15, 1), utc), v2 = A.VectorFromSphere(new A.Spherical(b.dec, b.ra * 15, 1), utc), points = [];
      for (let k = 0; k <= 12; k++) {
        const t2 = k / 12, v = new A.Vector(v1.x * (1 - t2) + v2.x * t2, v1.y * (1 - t2) + v2.y * t2, v1.z * (1 - t2) + v2.z * t2, utc), e = A.SphereFromVector(v);
        points.push(project(e.lon / 15, e.lat));
      }
      line(points, "#bcc8c0", 32e-4);
    }
    for (const p of visible.values()) if (p.mag <= 6) {
      const eligibilityRadius = Math.max(95e-5, 47e-4 - Math.max(-1, p.mag) * 58e-5), styledRadius = eligibilityRadius * 2.05, centreRadius = Math.hypot(p.x, p.y);
      if (centreRadius + eligibilityRadius < 1) nodes.push({ d: circlePath(p.x, p.y, styledRadius), fill: p.mag < 3 ? "#ffffff" : "#f5f7f3", ...centreRadius + styledRadius >= 1 ? { clipHorizon: true } : {} });
    }
    return { nodes, utc: utc.toISOString(), visibleStars: [...visible.values()].filter((s) => s.mag <= 6).length, attribution: data.credits.starCatalogue + "; " + data.credits.constellationLines + "; chart CC BY-SA 4.0", project };
  }
  var init_personalised_sky = __esm({
    "personalisation-product-integration/personalised-sky.mjs"() {
      init_personalised_scene();
    }
  });

  // personalisation-product-integration/place-autocomplete.mjs
  function addressSearchCopy(country = "GB") {
    const us = String(country).toUpperCase() === "US", place = us ? "city" : "town", postal = us ? "ZIP code" : "postcode";
    return { placeholder: "Start typing an address, " + place + " or " + postal, prompt: "Start typing an address, " + place + " or " + postal + ".", noMatch: "No match found. Try a nearby " + place + " or " + postal + "." };
  }
  var sequence = 0;
  function createPlaceAutocomplete({ input, button, results, status, search, onSelect, getCountry = () => "GB", delay = 450 }) {
    const doc = input.ownerDocument, id = "lp-place-options-" + ++sequence, cache = /* @__PURE__ */ new Map();
    let timer = null, version = 0, items = [];
    input.setAttribute("role", "combobox");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-expanded", "false");
    input.setAttribute("aria-controls", id);
    input.setAttribute("autocomplete", "off");
    results.id = id;
    results.setAttribute("role", "listbox");
    results.classList.add("lp-place-suggestions");
    results.hidden = true;
    let previousCopy = addressSearchCopy(getCountry());
    const wording = () => addressSearchCopy(getCountry());
    function refreshCopy() {
      const copy = wording();
      input.placeholder = copy.placeholder;
      if (status.textContent === previousCopy.prompt) status.textContent = copy.prompt;
      else if (status.textContent === previousCopy.noMatch) status.textContent = copy.noMatch;
      previousCopy = copy;
    }
    const clear = () => {
      results.replaceChildren();
      results.hidden = true;
      items = [];
      input.setAttribute("aria-expanded", "false");
    };
    async function find() {
      clearTimeout(timer);
      const query = input.value.trim(), current = ++version;
      clear();
      if (query.length < 3) {
        status.textContent = wording().prompt;
        button.disabled = false;
        return;
      }
      button.disabled = true;
      status.textContent = "Finding matching places\u2026";
      try {
        let hits = cache.get(query.toLocaleLowerCase());
        if (!hits) {
          hits = await search(query);
          if (!Array.isArray(hits)) throw Error("Place suggestions are unavailable.");
          cache.set(query.toLocaleLowerCase(), hits);
          if (cache.size > 20) cache.delete(cache.keys().next().value);
        }
        if (current !== version) return;
        hits.forEach((hit, index) => {
          const option = doc.createElement("button");
          option.type = "button";
          option.setAttribute("role", "option");
          option.id = id + "-" + index;
          option.textContent = hit.label;
          option.onclick = () => {
            if (onSelect(hit) === false) return;
            input.value = hit.label;
            clear();
            status.textContent = "Selected: " + hit.label;
          };
          option.onkeydown = (event) => {
            if (event.key === "ArrowDown" || event.key === "ArrowUp") {
              event.preventDefault();
              items[(index + (event.key === "ArrowDown" ? 1 : items.length - 1)) % items.length]?.focus();
            } else if (event.key === "Escape") {
              event.preventDefault();
              clear();
              input.focus();
            }
          };
          items.push(option);
          results.append(option);
        });
        results.hidden = !items.length;
        input.setAttribute("aria-expanded", String(!!items.length));
        status.textContent = items.length ? "Choose your place from the suggestions." : wording().noMatch;
      } catch (error) {
        if (current === version) {
          clear();
          status.textContent = error.message || "Place suggestions are unavailable. Please try again.";
        }
      } finally {
        if (current === version) button.disabled = false;
      }
    }
    input.addEventListener("input", () => {
      clearTimeout(timer);
      version++;
      clear();
      button.disabled = false;
      status.textContent = input.value.trim().length < 3 ? wording().prompt : "Looking for your place\u2026";
      if (input.value.trim().length >= 3) timer = setTimeout(find, delay);
    });
    input.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        void find();
      } else if (event.key === "ArrowDown" && items.length) {
        event.preventDefault();
        items[0].focus();
      } else if (event.key === "Escape") {
        clearTimeout(timer);
        version++;
        clear();
      }
    });
    button.onclick = () => void find();
    refreshCopy();
    return { search: find, refreshCopy, clear: () => {
      clearTimeout(timer);
      version++;
      clear();
    } };
  }

  // personalisation-product-integration/palette-swatches.mjs
  var PALETTE_CHOICES = Object.freeze([
    Object.freeze({ value: "original", label: "Original" }),
    Object.freeze({ value: "sage", label: "Sage" }),
    Object.freeze({ value: "rose", label: "Dusty rose" }),
    Object.freeze({ value: "blue", label: "Soft blue" })
  ]);
  var COMMON = {
    original: ["#f4f0e7", "#292823"],
    sage: ["#edf0e8", "#64765d"],
    rose: ["#f4e9e5", "#9b6e70"],
    blue: ["#eaf0f2", "#536f83"]
  };
  function paletteSwatchColours(handle, value) {
    const key = PALETTE_CHOICES.some((p) => p.value === value) ? value : "original";
    if (handle === "custom-song-wall-art") return [{ original: "#213e4a", sage: "#3c5044", rose: "#663f49", blue: "#254659" }[key], "#fff8ee"];
    if (handle === "personalized-anniversary-gift") return [{ original: "#d5c7b6", sage: "#9ca590", rose: "#bf9b95", blue: "#95a6b4" }[key], "#fffef9"];
    if (handle === "street-name-family-personal") return ["#fbfaf6", { original: "#e6bdb4", sage: "#c9d3bd", rose: "#ddb2b3", blue: "#bbcddd" }[key]];
    if (key === "original" && handle === "no-place-like-home-print") return ["#f0ebdf", "#778072"];
    if (key === "original" && handle === "home-beige-personal-print") return ["#f4f0e7", "#9a9186"];
    if (key === "original" && handle === "personalised-baby-poster") return ["#f6f0e8", "#292823"];
    return [...COMMON[key]];
  }
  function nextPaletteValue(value, key) {
    const index = Math.max(0, PALETTE_CHOICES.findIndex((p) => p.value === value));
    if (key === "Home") return PALETTE_CHOICES[0].value;
    if (key === "End") return PALETTE_CHOICES.at(-1).value;
    const direction = ["ArrowRight", "ArrowDown"].includes(key) ? 1 : ["ArrowLeft", "ArrowUp"].includes(key) ? -1 : 0;
    return direction ? PALETTE_CHOICES[(index + direction + PALETTE_CHOICES.length) % PALETTE_CHOICES.length].value : null;
  }
  var groupSequence = 0;
  function createPaletteSwatches({ document: doc = globalThis.document, name = "palette", label = "Colour palette", handle, value = "original" } = {}) {
    const group = doc.createElement("fieldset");
    group.className = "lp-field lp-palette-field";
    group.dataset.field = name;
    group.setAttribute("role", "radiogroup");
    const id = "lp-palette-" + ++groupSequence, legend = doc.createElement("legend");
    legend.id = id + "-label";
    legend.className = "lp-field-label";
    legend.textContent = label;
    group.setAttribute("aria-labelledby", legend.id);
    group.append(legend);
    const input = doc.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = PALETTE_CHOICES.some((p) => p.value === value) ? value : "original";
    group.append(input);
    const choices = doc.createElement("div");
    choices.className = "lp-palette-options";
    group.append(choices);
    const radios = [];
    function sync() {
      const selected = PALETTE_CHOICES.some((p) => p.value === input.value) ? input.value : "original";
      input.value = selected;
      for (const radio of radios) {
        radio.checked = radio.value === selected;
        radio.tabIndex = radio.checked ? 0 : -1;
      }
    }
    function select(next, { focus = false } = {}) {
      if (!PALETTE_CHOICES.some((p) => p.value === next)) return;
      const changed = input.value !== next;
      input.value = next;
      sync();
      if (focus) radios.find((r) => r.checked)?.focus({ preventScroll: true });
      if (changed) {
        const EventType = doc.defaultView?.Event || globalThis.Event;
        input.dispatchEvent(new EventType("input", { bubbles: true }));
      }
    }
    for (const choice of PALETTE_CHOICES) {
      const option = doc.createElement("label");
      option.className = "lp-palette-option";
      const radio = doc.createElement("input");
      radio.type = "radio";
      radio.name = id + "-choice";
      radio.value = choice.value;
      radio.className = "lp-palette-radio";
      const visual = doc.createElement("span");
      visual.className = "lp-palette-visual";
      const circle = doc.createElement("span");
      circle.className = "lp-palette-circle";
      circle.setAttribute("aria-hidden", "true");
      const [paper, accent] = paletteSwatchColours(handle, choice.value);
      circle.style.background = "linear-gradient(135deg," + paper + " 0 50%," + accent + " 50% 100%)";
      const text = doc.createElement("span");
      text.className = "lp-palette-name";
      text.textContent = choice.label;
      visual.append(circle, text);
      option.append(radio, visual);
      choices.append(option);
      radios.push(radio);
      radio.addEventListener("input", (event) => {
        event.stopPropagation();
        if (radio.checked) select(radio.value);
      });
      radio.addEventListener("keydown", (event) => {
        const next = nextPaletteValue(radio.value, event.key);
        if (next === null) return;
        event.preventDefault();
        select(next, { focus: true });
      });
    }
    input.addEventListener("input", sync);
    sync();
    return { element: group, input };
  }

  // personalisation-product-integration/personalised-storefront.mjs
  init_personalised_scene();

  // personalisation-product-integration/personalised-svg.mjs
  var escapeXml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;" })[c]);
  function personalisedSVG(scene, { bleed = 0 } = {}) {
    const { width: w, height: h, mm, background, nodes } = scene, b = bleed * w / mm[0];
    const clips = [];
    const paths = nodes.map((n, i) => {
      let p = `<path d="${escapeXml(n.d)}" transform="matrix(${n.matrix.join(" ")})" fill="${n.fill || "none"}"${n.stroke ? ` stroke="${n.stroke}" stroke-width="${n.strokeWidth}"` : ""}${n.opacity < 1 ? ` opacity="${n.opacity}"` : ""}/>`;
      if (n.clipPolygon) {
        clips.push(`<clipPath id="mapclip${i}"><polygon points="${n.clipPolygon.map((p2) => p2.join(",")).join(" ")}"/></clipPath>`);
        p = `<g clip-path="url(#mapclip${i})">${p}</g>`;
      }
      return p;
    }).join("");
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${mm[0] + 2 * bleed}mm" height="${mm[1] + 2 * bleed}mm" viewBox="${-b} ${-b} ${w + 2 * b} ${h + 2 * b}"><title>Your personalised print</title>${clips.length ? "<defs>" + clips.join("") + "</defs>" : ""}<rect x="${-b}" y="${-b}" width="${w + 2 * b}" height="${h + 2 * b}" fill="${background}"/>${paths}</svg>`;
  }

  // personalisation-product-integration/personalised-storefront.mjs
  init_personalised_fields();

  // personalisation-product-integration/print-catalogue.mjs
  var PRINT_COUNTRIES = ["AU", "AT", "BE", "BG", "CA", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "ID", "IE", "IL", "IT", "JP", "LV", "LT", "LU", "MY", "MT", "NL", "NZ", "NO", "PL", "PT", "SA", "SG", "SK", "SI", "KR", "ES", "SE", "CH", "TW", "TH", "TR", "AE", "GB", "US"];
  var PRINT_PRODUCTS = { "210x297": { "metric": { "mm": [210, 297], "productUid": "flat_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [203.2, 304.8], "productUid": "flat_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver" } }, "297x420": { "metric": { "mm": [297, 420], "productUid": "flat_a3_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [304.8, 406.4], "productUid": "flat_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "420x594": { "metric": { "mm": [420, 594], "productUid": "flat_a2_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [406.4, 609.6], "productUid": "flat_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "594x841": { "metric": { "mm": [594, 841], "productUid": "flat_a1_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [609.6, 812.8], "productUid": "flat_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "841x1189": { "metric": { "mm": [841, 1189], "productUid": "flat_a0_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": null }, "130x180": { "metric": { "mm": [130, 180], "productUid": "flat_130x180-mm-5r_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [127, 177.8], "productUid": "flat_5r-130x180-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "270x350": { "metric": { "mm": [270, 350], "productUid": "flat_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [279.4, 355.6], "productUid": "flat_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "300x400": { "metric": { "mm": [300, 400], "productUid": "flat_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [304.8, 406.4], "productUid": "flat_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "400x500": { "metric": { "mm": [400, 500], "productUid": "flat_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [406.4, 508], "productUid": "flat_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "400x600": { "metric": { "mm": [400, 600], "productUid": "flat_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [406.4, 609.6], "productUid": "flat_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "500x700": { "metric": { "mm": [500, 700], "productUid": "flat_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [508, 711.2], "productUid": "flat_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "600x800": { "metric": { "mm": [600, 800], "productUid": "flat_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [609.6, 812.8], "productUid": "flat_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "600x900": { "metric": { "mm": [600, 900], "productUid": "flat_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [609.6, 914.4], "productUid": "flat_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "700x1000": { "metric": { "mm": [700, 1e3], "productUid": "flat_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [711.2, 1016], "productUid": "flat_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "750x1000": { "metric": { "mm": [750, 1e3], "productUid": "flat_750x1000-mm-30x40-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [762, 1016], "productUid": "flat_30x40-inch-750x1000-mm_200-gsm-80lb-uncoated_4-0_ver" } } };
  function printProduct(variant, country = "GB") {
    if (!PRINT_COUNTRIES.includes(country)) throw Error("DELIVERY_COUNTRY_NOT_SUPPORTED");
    const key = variant.mm.map((n) => n === 595 ? 594 : n).join("x"), entry = PRINT_PRODUCTS[key];
    if (!entry) throw Error("PRINT_SIZE_NOT_MAPPED");
    const product = ["US", "CA"].includes(country) ? entry.northAmerica : entry.metric;
    if (!product) return { available: false, label: "This size is unavailable for this delivery country." };
    const units = country === "US" ? "in" : "cm", divisor = country === "US" ? 25.4 : 10;
    const format = (n) => String(Number((n / divisor).toFixed(2)));
    return { ...product, available: true, country, label: product.mm.map(format).join(" \xD7 ") + " " + units };
  }

  // personalisation-product-integration/frame-regional-catalogue.mjs
  var FRAME_REGIONAL_PRODUCTS = { "metric": [["210x297", "natural-wood", [210, 297], "framed_poster_mounted_210x297mm-8x12-inch_natural-wood_wood_w12xt22-mm_plexiglass_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "dark-wood", [210, 297], "framed_poster_mounted_210x297mm-8x12-inch_dark-wood_wood_w12xt22-mm_plexiglass_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "black", [210, 297], "framed_poster_mounted_210x297mm-8x12-inch_black_wood_w12xt22-mm_plexiglass_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "white", [210, 297], "framed_poster_mounted_210x297mm-8x12-inch_white_wood_w12xt22-mm_plexiglass_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "natural-wood", [297, 420], "framed_poster_mounted_a3_natural-wood_wood_w12xt22-mm_plexiglass_a3_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "dark-wood", [297, 420], "framed_poster_mounted_a3_dark-wood_wood_w12xt22-mm_plexiglass_a3_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "black", [297, 420], "framed_poster_mounted_a3_black_wood_w12xt22-mm_plexiglass_a3_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "white", [297, 420], "framed_poster_mounted_a3_white_wood_w12xt22-mm_plexiglass_a3_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "natural-wood", [420, 594], "framed_poster_mounted_a2_natural-wood_wood_w12xt22-mm_plexiglass_a2_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "dark-wood", [420, 594], "framed_poster_mounted_a2_dark-wood_wood_w12xt22-mm_plexiglass_a2_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "black", [420, 594], "framed_poster_mounted_a2_black_wood_w12xt22-mm_plexiglass_a2_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "white", [420, 594], "framed_poster_mounted_a2_white_wood_w12xt22-mm_plexiglass_a2_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "natural-wood", [594, 841], "framed_poster_mounted_a1_natural-wood_wood_w12xt22-mm_plexiglass_a1_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "dark-wood", [594, 841], "framed_poster_mounted_a1_dark-wood_wood_w12xt22-mm_plexiglass_a1_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "black", [594, 841], "framed_poster_mounted_a1_black_wood_w12xt22-mm_plexiglass_a1_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "white", [594, 841], "framed_poster_mounted_a1_white_wood_w12xt22-mm_plexiglass_a1_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "natural-wood", [270, 350], "framed_poster_mounted_270x350-mm-11x14-inch_natural-wood_wood_w12xt22-mm_plexiglass_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "dark-wood", [270, 350], "framed_poster_mounted_270x350-mm-11x14-inch_dark-wood_wood_w12xt22-mm_plexiglass_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "black", [270, 350], "framed_poster_mounted_270x350-mm-11x14-inch_black_wood_w12xt22-mm_plexiglass_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "white", [270, 350], "framed_poster_mounted_270x350-mm-11x14-inch_white_wood_w12xt22-mm_plexiglass_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "natural-wood", [300, 400], "framed_poster_mounted_300x400-mm-12x16-inch_natural-wood_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "dark-wood", [300, 400], "framed_poster_mounted_300x400-mm-12x16-inch_dark-wood_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "black", [300, 400], "framed_poster_mounted_300x400-mm-12x16-inch_black_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "white", [300, 400], "framed_poster_mounted_300x400-mm-12x16-inch_white_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "natural-wood", [400, 500], "framed_poster_mounted_400x500-mm-16x20-inch_natural-wood_wood_w12xt22-mm_plexiglass_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "dark-wood", [400, 500], "framed_poster_mounted_400x500-mm-16x20-inch_dark-wood_wood_w12xt22-mm_plexiglass_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "black", [400, 500], "framed_poster_mounted_400x500-mm-16x20-inch_black_wood_w12xt22-mm_plexiglass_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "white", [400, 500], "framed_poster_mounted_400x500-mm-16x20-inch_white_wood_w12xt22-mm_plexiglass_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "natural-wood", [400, 600], "framed_poster_mounted_400x600-mm-16x24-inch_natural-wood_wood_w12xt22-mm_plexiglass_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "dark-wood", [400, 600], "framed_poster_mounted_400x600-mm-16x24-inch_dark-wood_wood_w12xt22-mm_plexiglass_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "black", [400, 600], "framed_poster_mounted_400x600-mm-16x24-inch_black_wood_w12xt22-mm_plexiglass_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "white", [400, 600], "framed_poster_mounted_400x600-mm-16x24-inch_white_wood_w12xt22-mm_plexiglass_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "natural-wood", [500, 700], "framed_poster_mounted_500x700-mm-20x28-inch_natural-wood_wood_w12xt22-mm_plexiglass_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "dark-wood", [500, 700], "framed_poster_mounted_500x700-mm-20x28-inch_dark-wood_wood_w12xt22-mm_plexiglass_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "black", [500, 700], "framed_poster_mounted_500x700-mm-20x28-inch_black_wood_w12xt22-mm_plexiglass_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "white", [500, 700], "framed_poster_mounted_500x700-mm-20x28-inch_white_wood_w12xt22-mm_plexiglass_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "natural-wood", [600, 800], "framed_poster_mounted_600x800-mm-24x32-inch_natural-wood_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "dark-wood", [600, 800], "framed_poster_mounted_600x800-mm-24x32-inch_dark-wood_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "black", [600, 800], "framed_poster_mounted_600x800-mm-24x32-inch_black_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "white", [600, 800], "framed_poster_mounted_600x800-mm-24x32-inch_white_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "natural-wood", [600, 900], "framed_poster_mounted_600x900-mm-24x36-inch_natural-wood_wood_w12xt22-mm_plexiglass_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "dark-wood", [600, 900], "framed_poster_mounted_600x900-mm-24x36-inch_dark-wood_wood_w12xt22-mm_plexiglass_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "black", [600, 900], "framed_poster_mounted_600x900-mm-24x36-inch_black_wood_w12xt22-mm_plexiglass_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "white", [600, 900], "framed_poster_mounted_600x900-mm-24x36-inch_white_wood_w12xt22-mm_plexiglass_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "natural-wood", [700, 1e3], "framed_poster_mounted_700x1000-mm-28x40-inch_natural-wood_wood_w12xt22-mm_plexiglass_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "dark-wood", [700, 1e3], "framed_poster_mounted_700x1000-mm-28x40-inch_dark-wood_wood_w12xt22-mm_plexiglass_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "black", [700, 1e3], "framed_poster_mounted_700x1000-mm-28x40-inch_black_wood_w12xt22-mm_plexiglass_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "white", [700, 1e3], "framed_poster_mounted_700x1000-mm-28x40-inch_white_wood_w12xt22-mm_plexiglass_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver"]], "northAmerica": [["210x297", "natural-wood", [203.2, 304.8], "framed_poster_mounted_8x12-inch-210x297-mm_natural-wood_wood_w12xt22-mm_plexiglass_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "dark-wood", [203.2, 304.8], "framed_poster_mounted_8x12-inch-210x297-mm_dark-wood_wood_w12xt22-mm_plexiglass_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "black", [203.2, 304.8], "framed_poster_mounted_8x12-inch-210x297-mm_black_wood_w12xt22-mm_plexiglass_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "white", [203.2, 304.8], "framed_poster_mounted_8x12-inch-210x297-mm_white_wood_w12xt22-mm_plexiglass_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "natural-wood", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_natural-wood_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "dark-wood", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_dark-wood_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "black", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_black_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "white", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_white_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "natural-wood", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_natural-wood_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "dark-wood", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_dark-wood_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "black", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_black_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "white", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_white_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "natural-wood", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_natural-wood_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "dark-wood", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_dark-wood_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "black", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_black_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "white", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_white_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "natural-wood", [279.4, 355.6], "framed_poster_mounted_11x14-inch-270x350-mm_natural-wood_wood_w12xt22-mm_plexiglass_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "dark-wood", [279.4, 355.6], "framed_poster_mounted_11x14-inch-270x350-mm_dark-wood_wood_w12xt22-mm_plexiglass_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "black", [279.4, 355.6], "framed_poster_mounted_11x14-inch-270x350-mm_black_wood_w12xt22-mm_plexiglass_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "white", [279.4, 355.6], "framed_poster_mounted_11x14-inch-270x350-mm_white_wood_w12xt22-mm_plexiglass_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "natural-wood", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_natural-wood_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "dark-wood", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_dark-wood_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "black", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_black_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "white", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_white_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "natural-wood", [406.4, 508], "framed_poster_mounted_16x20-inch-400x500-mm_natural-wood_wood_w12xt22-mm_plexiglass_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "dark-wood", [406.4, 508], "framed_poster_mounted_16x20-inch-400x500-mm_dark-wood_wood_w12xt22-mm_plexiglass_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "black", [406.4, 508], "framed_poster_mounted_16x20-inch-400x500-mm_black_wood_w12xt22-mm_plexiglass_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "white", [406.4, 508], "framed_poster_mounted_16x20-inch-400x500-mm_white_wood_w12xt22-mm_plexiglass_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "natural-wood", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_natural-wood_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "dark-wood", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_dark-wood_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "black", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_black_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "white", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_white_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "natural-wood", [508, 711.2], "framed_poster_mounted_20x28-inch-500x700-mm_natural-wood_wood_w12xt22-mm_plexiglass_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "dark-wood", [508, 711.2], "framed_poster_mounted_20x28-inch-500x700-mm_dark-wood_wood_w12xt22-mm_plexiglass_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "black", [508, 711.2], "framed_poster_mounted_20x28-inch-500x700-mm_black_wood_w12xt22-mm_plexiglass_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "white", [508, 711.2], "framed_poster_mounted_20x28-inch-500x700-mm_white_wood_w12xt22-mm_plexiglass_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "natural-wood", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_natural-wood_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "dark-wood", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_dark-wood_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "black", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_black_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "white", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_white_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "natural-wood", [609.6, 914.4], "framed_poster_mounted_24x36-inch-600x900-mm_natural-wood_wood_w12xt22-mm_plexiglass_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "dark-wood", [609.6, 914.4], "framed_poster_mounted_24x36-inch-600x900-mm_dark-wood_wood_w12xt22-mm_plexiglass_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "black", [609.6, 914.4], "framed_poster_mounted_24x36-inch-600x900-mm_black_wood_w12xt22-mm_plexiglass_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "white", [609.6, 914.4], "framed_poster_mounted_24x36-inch-600x900-mm_white_wood_w12xt22-mm_plexiglass_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "natural-wood", [711.2, 1016], "framed_poster_mounted_28x40-inch-700x1000-mm_natural-wood_wood_w12xt22-mm_plexiglass_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "dark-wood", [711.2, 1016], "framed_poster_mounted_28x40-inch-700x1000-mm_dark-wood_wood_w12xt22-mm_plexiglass_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "black", [711.2, 1016], "framed_poster_mounted_28x40-inch-700x1000-mm_black_wood_w12xt22-mm_plexiglass_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "white", [711.2, 1016], "framed_poster_mounted_28x40-inch-700x1000-mm_white_wood_w12xt22-mm_plexiglass_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver"]] };
  var FRAME_COUNTRY_AVAILABILITY = { "GB": "111111111111111111111111111111111111111111111111", "US": "111111111111111111111111111111111111111111111111", "CA": "111111111111111111111111111111111111111111111111", "FR": "111111111111111111111111111111111111111111111111", "AU": "111111111111111111111111111111111111111111111111", "AT": "111111111111111111111111111111111111111111111111", "BE": "111111111111111111111111111111111111111111111111", "BG": "111111111111111111111111111111111111111111111111", "HR": "111111111111111111111111111111111111111111111111", "CZ": "111111111111111111111111111111111111111111111111", "DK": "111111111111111111111111111111111111111111111111", "EE": "111111111111111111111111111111111111111111111111", "FI": "111111111111111111111111111111111111111111111111", "DE": "111111111111111111111111111111111111111111111111", "GR": "111111111111111111111111111111111111111111111111", "HU": "111111111111111111111111111111111111111111111111", "ID": "111111111111111111111111111111111111111111111111", "IE": "111111111111111111111111111111111111111111111111", "IL": "111111111111111111111111111111111111111111111111", "IT": "111111111111111111111111111111111111111111111111", "JP": "111111111111111111111111111111111111111111111111", "LV": "111111111111111111111111111111111111111111111111", "LT": "111111111111111111111111111111111111111111111111", "LU": "111111111111111111111111111111111111111111111111", "MY": "111111111111111111111111111111111111111111111111", "MT": "111111111111111111111111111111111111111111111111", "NL": "111111111111111111111111111111111111111111111111", "NZ": "111111111111111111111111111111111111111111111111", "NO": "111111111111111111111111111111111111111111111111", "PL": "111111111111111111111111111111111111111111111111", "PT": "111111111111111111111111111111111111111111111111", "SA": "111111111111111111111111111111111111111111111111", "SG": "111111111111111111111111111111111111111111111111", "SK": "111111111111111111111111111111111111111111111111", "SI": "111111111111111111111111111111111111111111111111", "KR": "111111111111111111111111111111111111111111111111", "ES": "111111111111111111111111111111111111111111111111", "SE": "111111111111111111111111111111111111111111111111", "CH": "111111111111111111111111111111111111111111111111", "TW": "111111111111111111111111111111111111111111111111", "TH": "111111111111111111111111111111111111111111111111", "TR": "111111111111111111111111111111111111111111111111", "AE": "111111111111111111111111111111111111111111111111" };

  // personalisation-product-integration/frame-regional.mjs
  var match = (a, b) => a.length === b.length && a.every((v, i) => Math.abs(v - b[i]) < 0.01);
  function regionalFrameProduct(mm, finish, country = "GB") {
    if (!Array.isArray(mm) || mm.length !== 2) return null;
    const region = ["US", "CA"].includes(country) ? "northAmerica" : "metric", entries = FRAME_REGIONAL_PRODUCTS[region], key = mm.map((n) => n === 595 ? 594 : n).join("x");
    const i = entries.findIndex(([size, colour2, dimensions2]) => colour2 === finish && (size === key || match(dimensions2, mm)));
    if (i < 0 || FRAME_COUNTRY_AVAILABILITY[country]?.[i] !== "1") return null;
    const [sourceSize, , dimensions, productUid] = entries[i];
    return { sourceSize, mm: dimensions, productUid, country, assembly: "ready-to-hang" };
  }

  // personalisation-product-integration/standard-frame-geometry.mjs
  var FRAME_COLOURS = [["natural-wood", "Natural wood"], ["dark-wood", "Dark wood"], ["black", "Black"], ["white", "White"]];
  function frameEligibility(model) {
    if (!Array.isArray(model?.mm) || model.mm.length !== 2 || model.mm.some((n) => !Number.isFinite(n) || n <= 0)) return { eligible: false, reason: "Choose an available print size first." };
    const [w, h] = model.mm;
    if (w <= 130 && h <= 180) return { eligible: false, reason: "Frame not available in this size. Available as a print only." };
    if (w >= 750 || h > 1100) return { eligible: false, reason: "Frame not available in this size. Available as a print only." };
    if (model.country && !FRAME_COLOURS.some(([finish]) => regionalFrameProduct(model.mm, finish, model.country))) return { eligible: false, reason: "Frame not available for this size and delivery country. Your print is supplied unframed." };
    return { eligible: true, reason: "" };
  }

  // personalisation-product-integration/clean-frame-mockup.mjs
  var WOOD_PSD = { size: 1500, box: [331, 156, 1175, 1339] };
  function woodMockupLayout(mm, size = 1500) {
    const [left, top, right, bottom] = WOOD_PSD.box;
    const h = bottom - top, w = h * mm[0] / mm[1], x = (left + right - w) / 2;
    const scale = size / WOOD_PSD.size;
    return {
      x: x * scale,
      y: top * scale,
      w: w * scale,
      h: h * scale,
      sourceX: [0, left, right, 1500],
      sourceY: [0, top, bottom, 1500],
      targetX: [0, x, x + w, 1500].map((n) => n * scale),
      targetY: [0, top, bottom, 1500].map((n) => n * scale)
    };
  }
  function drawWoodOverlay(ctx, image, g) {
    for (let row = 0; row < 3; row++) for (let col = 0; col < 3; col++) {
      const sx = g.sourceX[col], sy = g.sourceY[row], sw = g.sourceX[col + 1] - sx, sh = g.sourceY[row + 1] - sy;
      const dx = g.targetX[col], dy = g.targetY[row], dw = g.targetX[col + 1] - dx, dh = g.targetY[row + 1] - dy;
      ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh);
    }
  }
  function createCleanFrameMockup(canvas, mockupUrl, { onRender = () => {
  }, frameLabel = "frame not included" } = {}) {
    let version = 0;
    const overlays = /* @__PURE__ */ new Map();
    function overlayFor(finish) {
      if (finish === "none") return Promise.resolve(null);
      const key = finish === "natural-wood" ? "wood" : finish;
      if (!overlays.has(key)) overlays.set(key, new Promise((resolve) => {
        const overlay = new Image();
        overlay.crossOrigin = "anonymous";
        overlay.onload = () => resolve(overlay);
        overlay.onerror = () => resolve(null);
        const src = new URL(mockupUrl, "https://berahgewesjy.shop/");
        if (key !== "wood") {
          src.pathname = src.pathname.replace("laboo-supplied-wood-overlay.webp", `laboo-supplied-${key}-overlay.webp`);
          src.search = "";
        }
        overlay.src = src.href;
      }));
      return overlays.get(key);
    }
    return async function update(url, mm = [300, 400], finish = "natural-wood") {
      const current = ++version;
      canvas.setAttribute("aria-busy", "true");
      const artwork = new Image();
      await new Promise((resolve, reject) => {
        artwork.onload = resolve;
        artwork.onerror = () => reject(Error("Frame artwork unavailable"));
        artwork.src = url;
      });
      const frame = await overlayFor(finish);
      if (current !== version) return;
      const framed = frameEligibility({ mm }).eligible && frame;
      const ctx = canvas.getContext("2d"), size = canvas.width;
      ctx.clearRect(0, 0, size, size);
      ctx.fillStyle = "#f7f1ee";
      ctx.fillRect(0, 0, size, size);
      if (framed) {
        const g = woodMockupLayout(mm, size);
        canvas.dataset.artworkRect = JSON.stringify([g.x / size, g.y / size, g.w / size, g.h / size]);
        ctx.drawImage(artwork, g.x, g.y, g.w, g.h);
        drawWoodOverlay(ctx, frame, g);
      } else {
        const scale = Math.min(size * 0.8 / mm[0], size * 0.88 / mm[1]), w = mm[0] * scale, h = mm[1] * scale;
        canvas.dataset.artworkRect = JSON.stringify([(size - w) / 2 / size, (size - h) / 2 / size, w / size, h / size]);
        ctx.save();
        ctx.shadowColor = "#0004";
        ctx.shadowBlur = size * 0.016;
        ctx.shadowOffsetX = -size * 0.013;
        ctx.shadowOffsetY = size * 0.012;
        ctx.drawImage(artwork, (size - w) / 2, (size - h) / 2, w, h);
        ctx.restore();
      }
      const label = { "natural-wood": "natural wood", "dark-wood": "dark wood", black: "black", white: "white" }[finish];
      canvas.setAttribute("aria-label", framed ? `Your personalised artwork in the supplied ${label} mockup. Framed example; ${frameLabel}.` : "Your personalised unframed print.");
      canvas.setAttribute("aria-busy", "false");
      onRender();
    };
  }

  // personalisation-product-integration/frame-purchase-rules.mjs
  var FRAME_LABELS = { "natural-wood": "Natural wood", "dark-wood": "Dark wood", black: "Black", white: "White" };
  function lookupFramePurchase(sourceVariantId, finish, country = "GB", purchases = {}) {
    if (!finish || finish === "none") return null;
    if (!Object.hasOwn(FRAME_LABELS, finish)) throw Error("INVALID_FRAME_FINISH");
    const found = Object.values(purchases).filter((p2) => p2.sourceVariantId === String(sourceVariantId) && p2.finish === finish);
    if (found.length !== 1) throw Error("FRAMED_VARIANT_NOT_AVAILABLE");
    const p = found[0];
    if (!/^framed_poster_mounted_/.test(p.productUid) || p.assembly !== "ready-to-hang" || p.country !== "GB") throw Error("INVALID_FRAMED_PRODUCT");
    const regional = regionalFrameProduct(p.mm, finish, country);
    if (!regional) throw Error("FRAMED_VARIANT_NOT_AVAILABLE_FOR_DESTINATION");
    return { ...p, ...regional };
  }

  // personalisation-product-integration/pdf-proof-renderer.mjs
  var libraryPromise;
  async function within(promise, message) {
    let timer;
    try {
      return await Promise.race([promise, new Promise((_, reject) => {
        timer = setTimeout(() => reject(Error(message)), 3e4);
      })]);
    } finally {
      clearTimeout(timer);
    }
  }
  async function renderSavedProof(saved, { rendererUrl, workerUrl, canvas, onProgress = () => {
  } }) {
    if (!rendererUrl || !workerUrl || !saved.printGeometry) throw Error("Please reload the page to prepare the latest proof.");
    onProgress("Loading your saved print file\u2026");
    const response = await fetch(saved.fileUrl, { cache: "no-store", credentials: "omit", signal: AbortSignal.timeout(2e4) });
    if (!response.ok) throw Error("Your saved print file could not be loaded. Please try again.");
    const bytes = new Uint8Array(await response.arrayBuffer());
    const hash = [...new Uint8Array(await crypto.subtle.digest("SHA-256", bytes))].map((n) => n.toString(16).padStart(2, "0")).join("");
    if (hash !== saved.sha256) throw Error("Your saved print file could not be verified. Please prepare it again.");
    onProgress("Opening your final proof\u2026");
    libraryPromise ||= import(rendererUrl).catch((e) => {
      libraryPromise = null;
      throw e;
    });
    const library = await within(libraryPromise, "Your proof viewer took too long to load. Please try again.");
    library.GlobalWorkerOptions.workerSrc = new URL(workerUrl, document.baseURI).href;
    const task = library.getDocument({ data: bytes, isEvalSupported: false, enableXfa: false });
    try {
      onProgress("Preparing your PDF preview\u2026");
      const document2 = await within(task.promise, "Your PDF preview took too long to open. Please try again.");
      if (document2.numPages !== 1) throw Error("Your print file has an unexpected page count.");
      const page = await document2.getPage(1), original = page.getViewport({ scale: 1 }), g = saved.printGeometry;
      if (!(await within(page.getOperatorList(), "Your print file took too long to prepare. Please try again.")).fnArray.length) throw Error("Your print proof has no drawing content. Please try again.");
      if (Math.abs(original.width * 25.4 / 72 - g.fileWidthMm) > 0.02 || Math.abs(original.height * 25.4 / 72 - g.fileHeightMm) > 0.02) throw Error("Your print dimensions could not be verified.");
      const viewport = page.getViewport({ scale: Math.min(2400 / original.width, 3200 / original.height) });
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      canvas.hidden = false;
      onProgress("Drawing your final proof\u2026");
      await within(page.render({ canvasContext: canvas.getContext("2d"), viewport, background: "white" }).promise, "Your print proof took too long to draw. Please try again.");
      const pixels = canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height).data;
      let coloured = 0;
      for (let i = 0; i < pixels.length; i += 4 * 97) if (pixels[i] < 240 || pixels[i + 1] < 240 || pixels[i + 2] < 240) coloured++;
      if (coloured < 10) throw Error("Your print proof did not draw correctly. Please try again.");
      return true;
    } finally {
      void task.destroy().catch(() => {
      });
    }
  }

  // personalisation-product-integration/proof-magnifier.mjs
  function magnifierCrop(width, height, displayWidth, displayHeight, x, y, size, zoom = 2) {
    const w = Math.min(width, size / zoom * width / displayWidth), h = Math.min(height, size / zoom * height / displayHeight);
    return { x: Math.max(0, Math.min(width - w, x * width - w / 2)), y: Math.max(0, Math.min(height - h, y * height - h / 2)), width: w, height: h };
  }
  function createProofMagnifier(pane, { nativeMobileZoom = false } = {}) {
    const stage = pane.querySelector(".laboo-final-proof-image"), sheet = pane.querySelector(".laboo-proof-trim-sheet");
    const toolbar = document.createElement("div");
    toolbar.className = "laboo-proof-zoom-tools";
    toolbar.innerHTML = '<button type="button" data-proof-zoom aria-pressed="false" disabled>Zoom details</button><span>Hover to magnify \xB7 On touch screens, turn on zoom and drag.</span>';
    if (nativeMobileZoom) {
      const hint = document.createElement("span");
      hint.className = "laboo-proof-pinch-hint";
      hint.textContent = "Pinch to zoom";
      toolbar.append(hint);
    }
    stage.after(toolbar);
    const lens = document.createElement("div");
    lens.className = "laboo-proof-magnifier";
    lens.hidden = true;
    lens.setAttribute("aria-hidden", "true");
    lens.innerHTML = "<canvas></canvas><span>2\xD7 detail</span>";
    stage.append(lens);
    const marker = document.createElement("div");
    marker.className = "laboo-proof-zoom-marker";
    marker.hidden = true;
    marker.setAttribute("aria-hidden", "true");
    sheet.append(marker);
    const button = toolbar.querySelector("button"), canvas = lens.querySelector("canvas");
    button.title = "Turn on zoom, then use the arrow keys or drag across the proof to inspect details.";
    let source = null, active = false, point = { x: 0.5, y: 0.5 }, frame = 0, dragging = false;
    function hide() {
      cancelAnimationFrame(frame);
      frame = 0;
      lens.hidden = true;
      marker.hidden = true;
    }
    function draw() {
      frame = 0;
      if (!source || source.hidden || !source.getClientRects().length) {
        hide();
        return;
      }
      const r = source.getBoundingClientRect(), s = stage.getBoundingClientRect(), size = Math.min(150, s.width - 16, s.height - 16);
      if (size <= 0) return;
      const crop = magnifierCrop(source.width, source.height, r.width, r.height, point.x, point.y, size);
      const dpr = Math.min(window.devicePixelRatio || 1, 2), pixels = Math.round(size * dpr);
      if (canvas.width !== pixels) {
        canvas.width = pixels;
        canvas.height = pixels;
      }
      const context = canvas.getContext("2d");
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = "high";
      context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, pixels, pixels);
      lens.style.width = lens.style.height = size + "px";
      const px = r.left - s.left + point.x * r.width, py = r.top - s.top + point.y * r.height;
      lens.style.left = Math.max(8, Math.min(s.width - size - 8, px - size / 2)) + "px";
      lens.style.top = Math.max(8, Math.min(s.height - size - 8, py - size - 22 >= 8 ? py - size - 22 : py + 22)) + "px";
      marker.style.left = crop.x / source.width * 100 + "%";
      marker.style.top = crop.y / source.height * 100 + "%";
      marker.style.width = crop.width / source.width * 100 + "%";
      marker.style.height = crop.height / source.height * 100 + "%";
      lens.hidden = marker.hidden = false;
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(draw);
    }
    function move(event) {
      if (!source) return;
      const r = source.getBoundingClientRect();
      point = { x: Math.max(0, Math.min(1, (event.clientX - r.left) / r.width)), y: Math.max(0, Math.min(1, (event.clientY - r.top) / r.height)) };
      schedule();
    }
    function setActive(value) {
      active = value;
      button.setAttribute("aria-pressed", String(active));
      button.textContent = active ? "Close zoom" : "Zoom details";
      sheet.classList.toggle("laboo-proof-zoom-active", active);
      if (active) schedule();
      else hide();
    }
    button.addEventListener("click", () => setActive(!active));
    button.addEventListener("keydown", (event) => {
      const directions = { ArrowLeft: [-0.03, 0], ArrowRight: [0.03, 0], ArrowUp: [0, -0.03], ArrowDown: [0, 0.03] };
      if (event.key === "Escape") {
        setActive(false);
        return;
      }
      if (!directions[event.key]) return;
      event.preventDefault();
      if (!active) setActive(true);
      const [dx, dy] = directions[event.key];
      point = { x: Math.max(0, Math.min(1, point.x + dx)), y: Math.max(0, Math.min(1, point.y + dy)) };
      schedule();
    });
    const nativeZoom = () => nativeMobileZoom && window.matchMedia("(max-width:767px)").matches;
    sheet.addEventListener("pointermove", (event) => {
      if (nativeZoom()) return;
      if (event.pointerType === "mouse" || active && dragging) move(event);
    });
    sheet.addEventListener("pointerdown", (event) => {
      if (nativeZoom() || !active || !source) return;
      dragging = true;
      sheet.setPointerCapture(event.pointerId);
      move(event);
    });
    sheet.addEventListener("pointerup", () => {
      dragging = false;
    });
    sheet.addEventListener("pointercancel", () => {
      dragging = false;
      hide();
    });
    sheet.addEventListener("pointerleave", () => {
      if (!active) hide();
    });
    pane.closest("dialog")?.addEventListener("close", () => setActive(false));
    pane.closest(".laboo-customiser-body")?.addEventListener("scroll", () => {
      hide();
    }, { passive: true });
    window.addEventListener("resize", () => {
      if (nativeZoom()) setActive(false);
      else hide();
    });
    return { setSource(value) {
      hide();
      setActive(false);
      source = value;
      button.disabled = !source;
      if (source) point = { x: 0.5, y: 0.5 };
    } };
  }

  // personalisation-product-integration/final-proof-panel.mjs
  function createFinalProofPanel(pane, { prepareProof, rendererUrl, workerUrl, country = "GB", onChange = () => {
  }, isActive = () => true, personalisationType, mobileApprovalPrompt = false }) {
    pane.classList.add("laboo-final-proof");
    pane.innerHTML = '<figure class="laboo-final-proof-figure"><div class="laboo-final-proof-image" aria-busy="false"><div class="laboo-proof-state" data-proof-state-panel hidden><div role="status" aria-live="polite" aria-atomic="true"><span class="laboo-proof-spinner" data-proof-spinner aria-hidden="true"></span><strong data-proof-state-title></strong><p data-proof-state-note></p></div><button type="button" data-proof-state-retry hidden>Try again</button></div><div class="laboo-proof-trim-sheet"><img data-final-proof-image alt="Your final personalised print proof" hidden><div class="laboo-proof-bleed-mask" aria-hidden="true"></div><div class="laboo-proof-cut-edge" aria-hidden="true"><span class="laboo-proof-crop laboo-proof-crop-tl"></span><span class="laboo-proof-crop laboo-proof-crop-tr"></span><span class="laboo-proof-crop laboo-proof-crop-bl"></span><span class="laboo-proof-crop laboo-proof-crop-br"></span></div><div class="laboo-proof-width" data-proof-width></div><div class="laboo-proof-height"><span data-proof-height></span></div></div></div><figcaption><span class="laboo-proof-cut-key"></span> Dashed line: cut edge \xB7 <span class="laboo-proof-bleed-key"></span> Shaded outer strip: bleed removed when trimmed.<br>Rulers show the finished print size. Guides will not be printed.</figcaption></figure><div class="laboo-final-proof-details"><h2 tabindex="-1">Check your final proof</h2><section class="laboo-proof-product-summary" data-proof-product-summary aria-label="What you\u2019ll receive" hidden><div class="laboo-proof-product-thumb"><img data-proof-product-image width="112" height="140" alt="" decoding="async" hidden><span data-proof-product-image-status>Loading preview\u2026</span></div><div><h3>What you\u2019ll receive</h3><dl><div><dt>Print size</dt><dd data-proof-product-size></dd></div><div><dt>Finish</dt><dd data-proof-product-finish></dd></div></dl><p data-proof-product-inclusions></p></div></section><p class="laboo-step-intro">This preview comes directly from your saved print PDF. The area inside the dashed line is your finished print. Any white areas shown are part of your print.</p><p class="laboo-order-summary"></p><p class="laboo-proof-dimensions" data-proof-dimensions></p><p data-final-proof-status role="status" aria-live="polite"></p><button type="button" data-proof-retry hidden>Try preparing your proof again</button><p class="laboo-proof-pdf-link"><a data-final-proof-pdf target="_blank" rel="noopener" hidden>View the saved print PDF</a></p><label class="laboo-final-proof-consent"><input type="checkbox" data-proof-confirm disabled> <span>I have checked the name, number, size and layout and approve this print.</span></label><p class="laboo-proof-error" data-proof-error role="status" aria-live="polite"></p></div>';
    let image = pane.querySelector("[data-final-proof-image]");
    if (personalisationType === "personalised") pane.querySelector(".laboo-final-proof-consent span").textContent = "I have checked the words, dates, size and layout and approve this print.";
    if (personalisationType === "map") pane.querySelector(".laboo-final-proof-consent span").textContent = "I have checked the map location, words, size, layout and frame colour and approve this print.";
    const consent = pane.querySelector("[data-proof-confirm]"), status = pane.querySelector("[data-final-proof-status]"), error = pane.querySelector("[data-proof-error]"), retry = pane.querySelector("[data-proof-retry]"), pdf = pane.querySelector("[data-final-proof-pdf]");
    const stage = pane.querySelector(".laboo-final-proof-image"), statePanel = pane.querySelector("[data-proof-state-panel]"), stateTitle = pane.querySelector("[data-proof-state-title]"), stateNote = pane.querySelector("[data-proof-state-note]"), spinner = pane.querySelector("[data-proof-spinner]"), stateRetry = pane.querySelector("[data-proof-state-retry]");
    function setProofState(state, message = "") {
      const loading = state === "loading";
      stage.dataset.proofState = state;
      stage.setAttribute("aria-busy", String(loading));
      statePanel.hidden = state !== "loading" && state !== "error";
      spinner.hidden = !loading;
      stateRetry.hidden = state !== "error";
      stateTitle.textContent = loading ? "Preparing your print preview\u2026" : "We couldn\u2019t load your preview.";
      stateNote.textContent = message || (loading ? "This can take a moment. Please keep this window open." : "Please try again.");
    }
    const productSummary = pane.querySelector("[data-proof-product-summary]"), productImage = pane.querySelector("[data-proof-product-image]"), productImageStatus = pane.querySelector("[data-proof-product-image-status]");
    function clearProductSummary() {
      productSummary.hidden = true;
      productImage.onload = productImage.onerror = null;
      productImage.removeAttribute("src");
      productImage.hidden = true;
      productImageStatus.hidden = false;
      productImageStatus.textContent = "Loading preview\u2026";
    }
    function updateProductSummary(result, current) {
      const framed = !!result.finish && result.finish !== "none";
      const finish = framed ? { "natural-wood": "Natural wood", "dark-wood": "Dark wood", black: "Black", white: "White" }[result.finish] || result.frameLabel : "Print only";
      pane.querySelector("[data-proof-product-size]").textContent = result.size;
      pane.querySelector("[data-proof-product-finish]").textContent = framed ? finish + " frame" : "Print only";
      pane.querySelector("[data-proof-product-inclusions]").textContent = framed ? "Your artwork is fitted inside the frame with protective Perspex. Arrives assembled and ready to hang." : "Unframed print on matte paper. Frame not included.";
      productSummary.hidden = false;
      productSummary.dataset.finish = result.finish || "none";
      productImage.alt = framed ? "Your personalised artwork in the selected " + finish.toLowerCase() + " frame. Frame included." : "Your personalised unframed print. Frame not included.";
      const url = framed ? result.cartPreviewUrl : result.previewUrl;
      productImage.onload = () => {
        if (current !== version) return;
        productImage.hidden = false;
        productImageStatus.hidden = true;
      };
      productImage.onerror = () => {
        if (current !== version) return;
        productImage.hidden = true;
        productImageStatus.hidden = false;
        productImageStatus.textContent = "Preview unavailable";
      };
      if (url) productImage.src = url;
      else productImageStatus.textContent = "Preview unavailable";
    }
    const magnifier = createProofMagnifier(pane, { nativeMobileZoom: mobileApprovalPrompt });
    const approvalLabel = consent.closest("label");
    error.id = "laboo-final-proof-approval-error";
    consent.setAttribute("aria-describedby", error.id);
    const clearApprovalError = () => {
      approvalLabel.classList.remove("laboo-proof-consent-error");
      consent.removeAttribute("aria-invalid");
      error.textContent = "";
    };
    let saved = null, version = 0, imageReady = false;
    function invalidate() {
      version++;
      clearProductSummary();
      setProofState("idle");
      saved = null;
      imageReady = false;
      pane.querySelector("[data-gift-proof-review]")?.remove();
      magnifier.setSource(null);
      consent.checked = false;
      consent.disabled = true;
      image.hidden = true;
      pdf.hidden = true;
      retry.hidden = true;
      clearApprovalError();
      pane.querySelector(".laboo-proof-trim-sheet").dataset.ready = "false";
      for (const selector of ["[data-proof-width]", "[data-proof-height]", "[data-proof-dimensions]"]) pane.querySelector(selector).textContent = "";
      if (isActive()) status.textContent = "Your design changed. Go back and prepare a new final proof.";
      onChange();
    }
    async function prepare() {
      invalidate();
      const current = version;
      setProofState("loading");
      status.textContent = "Preparing your final print proof\u2026";
      try {
        const result = await prepareProof();
        if (current !== version || !isActive()) {
          if (current === version) setProofState("idle");
          return;
        }
        const description = result.personalisationSummary || `${result.name} / ${result.number}`;
        updateProductSummary(result, current);
        const canvas = document.createElement("canvas");
        canvas.hidden = true;
        canvas.setAttribute("data-final-proof-image", "");
        canvas.setAttribute("role", "img");
        canvas.setAttribute("aria-label", `Final proof: ${description}, ${result.size}`);
        image.replaceWith(canvas);
        image = canvas;
        await renderSavedProof(result, { rendererUrl, workerUrl, canvas, onProgress: (message) => {
          if (current === version && isActive()) status.textContent = message;
        } });
        if (current !== version || !isActive()) {
          if (current === version) setProofState("idle");
          return;
        }
        saved = result;
        const g = result.printGeometry, b = g.bleedMm, sheet = pane.querySelector(".laboo-proof-trim-sheet");
        for (const [side, value] of Object.entries(b)) sheet.style.setProperty("--proof-" + side, `${100 * value / (side === "top" || side === "bottom" ? g.fileHeightMm : g.fileWidthMm)}%`);
        const format = (mm) => `${Number((mm / (country === "US" ? 25.4 : 10)).toFixed(2))} ${country === "US" ? "in" : "cm"}`;
        pane.querySelector("[data-proof-width]").textContent = format(g.widthMm);
        pane.querySelector("[data-proof-height]").textContent = format(g.heightMm);
        pane.querySelector("[data-proof-dimensions]").textContent = `Finished print: ${format(g.widthMm)} \xD7 ${format(g.heightMm)}. Bleed outside the cut edge: ${b.left} mm left, ${b.right} mm right, ${b.top} mm top and ${b.bottom} mm bottom.`;
        pane.querySelector("[data-gift-proof-review]")?.remove();
        if (result.gift) {
          const review = document.createElement("section");
          review.dataset.giftProofReview = "";
          review.className = "laboo-gift-proof-review";
          const heading = document.createElement("strong");
          heading.textContent = "Your gift message";
          const recipient = document.createElement("p");
          recipient.textContent = "To " + result.gift.recipientName + " \xB7 " + result.gift.recipientEmail;
          const note = document.createElement("p");
          note.style.whiteSpace = "pre-wrap";
          note.textContent = result.gift.message;
          const sender = document.createElement("p");
          sender.textContent = "From " + result.gift.fromName;
          const timing = document.createElement("p");
          timing.textContent = "Emailed after courier-confirmed delivery. Your gift note is separate from the printed artwork.";
          review.append(heading, recipient, note, sender, timing);
          pane.querySelector(".laboo-final-proof-consent").before(review);
        }
        const frame = result.finish && result.finish !== "none";
        pane.querySelector(".laboo-order-summary").textContent = description;
        pane.querySelector(".laboo-final-proof-consent span").textContent = (result.personalisationType || personalisationType) === "personalised" ? frame ? "I have checked the words, dates, size, layout and selected frame and approve this ready-to-hang print." : "I have checked the words, dates, size and layout and approve this print." : result.personalisationType === "map" ? frame ? "I have checked the map location, words, size, layout and frame colour and approve this ready-to-hang print." : "I have checked the map location, words, size and layout and approve this print." : frame ? "I have checked the name, number, size, layout and frame colour and approve this ready-to-hang print." : "I have checked the name, number, size and layout and approve this print.";
        sheet.dataset.ready = "true";
        imageReady = true;
        setProofState("ready");
        magnifier.setSource(canvas);
        consent.disabled = false;
        status.textContent = frame ? "Check the print PDF and selected frame details, then tick the approval box. The frame covers approximately 4\u20135 mm at each edge." : "Check this saved proof, then tick the approval box to continue.";
        pdf.href = result.fileUrl;
        pdf.hidden = false;
        onChange();
      } catch (e) {
        if (current !== version) return;
        image.hidden = true;
        status.textContent = e.message || "Your proof could not be prepared.";
        setProofState("error", status.textContent);
        retry.hidden = false;
        onChange();
      }
    }
    consent.addEventListener("change", () => {
      clearApprovalError();
      onChange();
    });
    retry.addEventListener("click", prepare);
    stateRetry.addEventListener("click", prepare);
    const approved = () => !!saved && imageReady && consent.checked && !consent.disabled;
    return { prepare, invalidate, isReady: () => !!saved && imageReady && !consent.disabled, isApproved: approved, getProof: () => approved() ? saved : null, validate() {
      if (approved()) return true;
      error.textContent = "Please check your final proof and tick the approval box.";
      if (mobileApprovalPrompt && window.matchMedia("(max-width:767px)").matches) {
        approvalLabel.classList.add("laboo-proof-consent-error");
        consent.setAttribute("aria-invalid", "true");
        consent.focus({ preventScroll: true });
        approvalLabel.scrollIntoView({ block: "center", behavior: window.matchMedia("(prefers-reduced-motion:reduce)").matches ? "instant" : "smooth" });
      } else consent.focus();
      return false;
    } };
  }

  // personalisation-product-integration/personalised-side-cart.mjs
  async function showPersonalisedSideCart(root2, response) {
    const items = document.getElementById("AjaxCartForm"), subtotal = document.getElementById("AjaxCartSubtotal"), sidebar = document.getElementById("site-cart-sidebar");
    if (!items || !subtotal || typeof sidebar?.show !== "function") return false;
    const text = typeof window.labooCartSectionText === "function" ? await window.labooCartSectionText(response) : await fetch((window.Shopify?.routes?.root || "/") + "?section_id=helper-cart").then((r) => {
      if (!r.ok) throw Error("Cart refresh failed");
      return r.text();
    });
    const section = new DOMParser().parseFromString(text, "text/html"), nextItems = section.getElementById("AjaxCartForm"), nextSubtotal = section.getElementById("AjaxCartSubtotal");
    if (!nextItems || !nextSubtotal) throw Error("Cart refresh failed");
    items.innerHTML = nextItems.innerHTML;
    items.ajaxifyCartItems?.();
    subtotal.innerHTML = nextSubtotal.innerHTML;
    const count = items.querySelector("[data-cart-count]")?.textContent, total = items.querySelector("[data-cart-total]")?.textContent;
    if (count != null) document.querySelectorAll("[data-header-cart-count]").forEach((e) => e.textContent = count);
    if (total != null) document.querySelectorAll("[data-header-cart-total]").forEach((e) => e.textContent = total);
    root2.closest("dialog")?.close();
    sidebar.show();
    document.getElementById("cart-recommendations-sidebar")?.generateRecommendations?.();
    document.getElementById("screen-reader-info")?.replaceChildren(document.createTextNode("Your personalised print was added to your basket."));
    return true;
  }

  // personalisation-product-integration/generic-personalisation-flow.mjs
  var mapHandles = /* @__PURE__ */ new Set(["love-map-poster", "heart-on-map-print", "custom-anniversary-gift"]);
  var isGenericMap = (p) => mapHandles.has(p.handle);
  var hasGenericLocation = (p) => isGenericMap(p) || p.handle === "custom-star-map";
  function genericSteps(p, { giftEnabled = false, giftSelected = false } = {}) {
    const derived = new Set(hasGenericLocation(p) ? ["latitude", "longitude", "utcOffset", "timeZone"] : []);
    const steps = [];
    for (const f of p.fields) {
      if (derived.has(f.key)) continue;
      steps.push({ id: f.key, title: f.label, keys: [f.key], kind: f.key === "location" && hasGenericLocation(p) ? "location" : "field" });
    }
    return [
      ...steps,
      { id: "size", title: "Choose your print size", keys: [], kind: "size" },
      { id: "frame", title: "Choose your frame", keys: [], kind: "frame" },
      ...giftEnabled ? [{ id: "gift", title: "Gift message", keys: [], kind: "gift" }, ...giftSelected ? [["recipientName", "Recipient\u2019s name"], ["recipientEmail", "Recipient\u2019s email"], ["fromName", "From"], ["message", "Your gift message"]].map(([key, title]) => ({ id: "gift-" + key, title, keys: [], kind: "gift", giftField: key })) : []] : [],
      { id: "proof", title: "Check your print", keys: [], kind: "proof" }
    ];
  }
  function genericSummary(p, values) {
    return p.fields.filter((f) => !["latitude", "longitude", "utcOffset", "timeZone", "palette"].includes(f.key) && values[f.key]).map((f) => f.label + ": " + values[f.key]).join(" \xB7 ");
  }
  function genericStage(step) {
    return step.kind === "gift" ? "gift" : ["size", "frame"].includes(step.kind) ? "size" : step.kind === "proof" ? "proof" : "personalise";
  }

  // personalisation-product-integration/personalised-timezone.mjs
  var formatters = /* @__PURE__ */ new Map();
  function formatter(timeZone) {
    if (!formatters.has(timeZone)) formatters.set(timeZone, new Intl.DateTimeFormat("en-GB", { timeZone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }));
    return formatters.get(timeZone);
  }
  function localTimeOffsets({ date, time, timeZone }) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(time)) throw Error("Choose a valid date and time.");
    let f;
    try {
      f = formatter(timeZone);
    } catch {
      throw Error("Choose a location with a valid time zone.");
    }
    const naive = Date.parse(date + "T" + time + ":00Z"), matches = [];
    for (let quarter = -48; quarter <= 56; quarter++) {
      const utc = naive - quarter * 9e5, parts = Object.fromEntries(f.formatToParts(new Date(utc)).filter((p) => p.type !== "literal").map((p) => [p.type, p.value]));
      if (`${parts.year}-${parts.month}-${parts.day}` === date && `${parts.hour}:${parts.minute}` === time) matches.push({ offset: quarter / 4, utc: new Date(utc).toISOString() });
    }
    return matches.sort((a, b) => a.utc.localeCompare(b.utc));
  }

  // personalisation-product-integration/selected-size-guide.mjs
  var PERSON_MM = 1778;
  function createSelectedSizeGuide(container) {
    container.innerHTML = `<h3>See the size</h3><svg viewBox="0 0 2400 2050" role="img" aria-label="Selected print compared with a person" data-selected-size-guide>
    <title data-guide-title>Selected print size comparison</title>
    <line x1="100" y1="1850" x2="2260" y2="1850" stroke="#d9d5cf" stroke-width="7"/>
    <image href="https://berahgewesjy.shop/cdn/shop/files/Person_Height_ad0db3fc-162d-4483-9f1f-371d99b6bd16.png?v=1770021352&amp;width=200" x="260" y="72" width="482" height="1778" preserveAspectRatio="xMidYMax meet"/>
    <text x="500" y="2000" text-anchor="middle" data-guide-person></text>
    <rect data-guide-frame fill="#262626"/>
    <image data-guide-art preserveAspectRatio="none"/>
    <g stroke="#777" stroke-width="6" fill="none"><path data-guide-width-line/><path data-guide-height-line/></g>
    <text data-guide-width text-anchor="middle"/><text data-guide-height text-anchor="middle"/>
  </svg><p class="laboo-scale-guide-note">Illustrative comparison. Measurements are for the print; frame shown for scale and not included.</p>`;
    const svg = container.querySelector("svg"), get = (name) => container.querySelector(`[data-guide-${name}]`);
    function attrs(el, values) {
      for (const [key, value] of Object.entries(values)) el.setAttribute(key, String(value));
    }
    return {
      update(model, finish) {
        if (!model) return;
        const [width, height] = model.mm, x = 1600 - width / 2, y = 800 - height / 2, edge = 12;
        attrs(get("frame"), { x: x - edge, y: y - edge, width: width + edge * 2, height: height + edge * 2 });
        get("frame").setAttribute("fill", finish === "natural-wood" ? "#c9ad88" : finish === "white" ? "#e7e5e0" : "#262626");
        get("frame").setAttribute("visibility", finish === "none" ? "hidden" : "visible");
        attrs(get("art"), { x, y, width, height });
        get("width-line").setAttribute("d", `M${x} ${y - 70}v-60m0 30h${width}m0-30v60`);
        get("height-line").setAttribute("d", `M${x + width + 70} ${y}h60m-30 0v${height}m-30 0h60`);
        attrs(get("width"), { x: 1600, y: y - 150 });
        get("width").textContent = model.widthText;
        attrs(get("height"), { x: x + width + 210, y: 800, transform: `rotate(90 ${x + width + 210} 800)` });
        get("height").textContent = model.heightText;
        get("person").textContent = model.personLabel;
        const label = `${model.label} print compared with a ${model.personLabel.replace("Person: ", "")} person.${finish === "none" ? " Print only." : " Frame illustrative."}`;
        svg.setAttribute("aria-label", label);
        get("title").textContent = label;
        Object.assign(svg.dataset, { widthMm: String(width), heightMm: String(height), personMm: String(PERSON_MM), units: model.unit });
      },
      setArtwork(url) {
        get("art").setAttribute("href", url);
      }
    };
  }

  // personalisation-product-integration/gift-message.mjs
  function normaliseGift(input) {
    if (input == null || input.enabled === false) return null;
    if (typeof input !== "object" || input.enabled !== true) throw Error("Choose whether to add a gift message.");
    const text = (key, max, label) => {
      if (typeof input[key] !== "string") throw Error(`Enter ${label}.`);
      const value = input[key].normalize("NFC").trim();
      if (!value || value.length > max || /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(value)) throw Error(`Enter ${label} using up to ${max} characters.`);
      return value;
    };
    const recipientName = text("recipientName", 80, "the recipient's name"), fromName = text("fromName", 80, "your name"), message = text("message", 300, "a gift message");
    const recipientEmail = text("recipientEmail", 254, "the recipient's email address");
    if (/[\r\n\t]/.test(recipientName + fromName)) throw Error("Enter names on one line.");
    if (!/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(recipientEmail)) throw Error("Enter a valid recipient email address.");
    return { enabled: true, recipientName, recipientEmail, fromName, message, delivery: "after-confirmed-delivery" };
  }
  function giftOrderProperties(input) {
    const gift = normaliseGift(input);
    return gift ? { "Gift recipient": gift.recipientName, "Gift from": gift.fromName, "Gift message": gift.message, "Gift delivery": "Email after courier-confirmed delivery", _Laboo_Is_Gift: "true", _Laboo_Gift_Recipient_Email: gift.recipientEmail, _Laboo_Gift_Email_Status: "pending_order" } : {};
  }

  // personalisation-product-integration/gift-message-ui.mjs
  function createGiftMessage(host, { productId, api, onChange = () => {
  }, onAvailability = () => {
  } } = {}) {
    const section = document.createElement("section");
    section.className = "laboo-gift-section";
    section.hidden = true;
    section.innerHTML = '<div data-gift-choice><p class="laboo-gift-packaging-note"><strong>No invoice, receipt or pricing is included in the parcel.</strong></p><label class="laboo-gift-toggle"><input type="checkbox" data-gift-enabled> Add a gift message <small>Optional</small></label><p class="laboo-gift-delivery-note">We\u2019ll email your note to the recipient after the courier confirms delivery.</p></div><div class="laboo-gift-fields" hidden><div data-gift-part="recipientName"><label for="laboo-gift-to">Recipient\u2019s name</label><input id="laboo-gift-to" data-gift="recipientName" maxlength="80" autocomplete="off"></div><div data-gift-part="recipientEmail"><label for="laboo-gift-email">Recipient\u2019s email</label><input id="laboo-gift-email" data-gift="recipientEmail" type="email" maxlength="254" autocomplete="off" inputmode="email"><p>We\u2019ll use this address only to send your gift message after confirmed delivery.</p></div><div data-gift-part="fromName"><label for="laboo-gift-from">From</label><input id="laboo-gift-from" data-gift="fromName" maxlength="80" autocomplete="off"></div><div data-gift-part="message"><label for="laboo-gift-message">Your gift message</label><textarea id="laboo-gift-message" data-gift="message" maxlength="300" rows="3" placeholder="Write a personal note"></textarea><p><span data-gift-count>0</span>/300 characters</p></div></div><p data-gift-error role="status" aria-live="polite"></p>';
    host.append(section);
    const toggle = section.querySelector("[data-gift-enabled]"), fields = section.querySelector(".laboo-gift-fields"), error = section.querySelector("[data-gift-error]");
    let enabled = false;
    const inputs = [...fields.querySelectorAll("[data-gift]")];
    function getGift() {
      return normaliseGift(enabled && toggle.checked ? { enabled: true, ...Object.fromEntries(inputs.map((el) => [el.dataset.gift, el.value])) } : null);
    }
    function validate(field) {
      error.textContent = "";
      for (const el of inputs) el.removeAttribute("aria-invalid");
      if (!enabled || !toggle.checked) return true;
      if (field) {
        const el = inputs.find((el2) => el2.dataset.gift === field), value = el?.value.trim();
        if (value && (field !== "recipientEmail" || /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(value)) && (!["recipientName", "fromName"].includes(field) || !/[\r\n\t]/.test(value))) return true;
        error.textContent = field === "recipientEmail" ? "Enter a valid recipient email address." : "Please complete this field.";
        el?.setAttribute("aria-invalid", "true");
        el?.focus({ preventScroll: true });
        return false;
      }
      try {
        getGift();
        return true;
      } catch (e) {
        error.textContent = e.message;
        const el = inputs.find((el2) => !el2.value.trim() || el2.type === "email" && !el2.validity.valid);
        el?.setAttribute("aria-invalid", "true");
        el?.focus({ preventScroll: true });
        return false;
      }
    }
    function changed() {
      fields.hidden = !toggle.checked;
      section.querySelector("[data-gift-count]").textContent = String(section.querySelector('[data-gift="message"]').value.length);
      error.textContent = "";
      for (const el of inputs) el.removeAttribute("aria-invalid");
      onChange();
    }
    toggle.addEventListener("change", changed);
    fields.addEventListener("input", changed);
    const ready = (async () => {
      try {
        const response = await fetch(new URL("/shopify/gift-config?productId=" + encodeURIComponent(productId), api), { credentials: "omit" });
        if (!response.ok) return false;
        const config = await response.json();
        enabled = config.enabled === true;
        section.hidden = !enabled;
        onAvailability();
        return enabled;
      } catch {
        return false;
      }
    })();
    return { section, choice: section.querySelector("[data-gift-choice]"), fields, inputs, ready, getGift, getGiftKey: () => enabled && toggle.checked ? JSON.stringify(inputs.map((el) => [el.dataset.gift, el.value])) : null, validate, isEnabled: () => enabled, isSelected: () => enabled && toggle.checked };
  }

  // personalisation-product-integration/psd-material-artwork-renderer.mjs
  function psdDetailEligible(key, mm) {
    if (!Array.isArray(mm) || !(mm[0] > 0 && mm[1] > 0)) return false;
    if (mm[0] === mm[1]) return key === "paper-square" || /^(frame|pack)-(natural-wood|dark-wood|black|white)-square$/.test(key);
    return mm[1] > mm[0] ? key === "paper" || /^(frame-(natural-wood|dark-wood|black|white)|pack-(natural-wood|dark-wood|black|white)-portrait)$/.test(key) : key === "paper-landscape" || /^(frame|pack)-(natural-wood|dark-wood|black|white)-landscape$/.test(key);
  }
  function psdDetailInverse(q) {
    const [[x0, y0], [x1, y1], [x2, y2], [x3, y3]] = q, dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3, den = dx1 * dy2 - dx2 * dy1, g = (dx3 * dy2 - dx2 * dy3) / den, h = (dx1 * dy3 - dx3 * dy1) / den, a = x1 - x0 + g * x1, b = x3 - x0 + h * x3, c = x0, d2 = y1 - y0 + g * y1, e = y3 - y0 + h * y3, f = y0;
    return [e - f * h, c * h - b, b * f - c * e, f * g - d2, a - c * g, c * d2 - a * f, d2 * h - e * g, b * g - a * h, a * e - b * d2];
  }
  function compositePsdDetail(source, background, mask, template, warp = null) {
    const { width: w, height: h, data: bg } = background, result = new Uint8ClampedArray(bg), s = source.data, sw = source.width, sh = source.height, m = psdDetailInverse(template.quad.map(([x, y]) => [x * w / template.canvas[0], y * h / template.canvas[1]]));
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const offset = (y * w + x) * 4, alpha = mask.data[offset] / 255 * template.opacity;
      if (alpha === 0) continue;
      const X = x + 0.5, Y = y + 0.5, z = m[6] * X + m[7] * Y + m[8], uv = warp ? psdDetailWarpAt(warp, (x + 0.5) * warp.width / w - 0.5, (y + 0.5) * warp.height / h - 0.5) : [(m[0] * X + m[1] * Y + m[2]) / z, (m[3] * X + m[4] * Y + m[5]) / z], u = Math.max(0, Math.min(1, uv[0])), v = Math.max(0, Math.min(1, uv[1])), px = u * (sw - 1), py = v * (sh - 1), sx = Math.floor(px), sy = Math.floor(py), fx = px - sx, fy = py - sy, p = (sy * sw + sx) * 4, q = (sy * sw + Math.min(sx + 1, sw - 1)) * 4, r = (Math.min(sy + 1, sh - 1) * sw + sx) * 4, t2 = (Math.min(sy + 1, sh - 1) * sw + Math.min(sx + 1, sw - 1)) * 4, weights = [(1 - fx) * (1 - fy), fx * (1 - fy), (1 - fx) * fy, fx * fy];
      for (let c = 0; c < 3; c++) {
        const ink = s[p + c] * weights[0] + s[q + c] * weights[1] + s[r + c] * weights[2] + s[t2 + c] * weights[3];
        result[offset + c] = bg[offset + c] * (1 - alpha) + bg[offset + c] * ink / 255 * alpha;
      }
    }
    return result;
  }
  function decodePsdDetailWarp(image) {
    const data = new Float32Array(image.width * image.height * 2);
    for (let i = 0; i < image.width * image.height; i++) {
      const p = i * 4;
      data[i * 2] = (image.data[p] << 4 | image.data[p + 2] >> 4) / 4095;
      data[i * 2 + 1] = (image.data[p + 1] << 4 | image.data[p + 2] & 15) / 4095;
    }
    return { width: image.width, height: image.height, data };
  }
  function psdDetailWarpAt(warp, x, y) {
    x = Math.max(0, Math.min(warp.width - 1, x));
    y = Math.max(0, Math.min(warp.height - 1, y));
    const sx = Math.floor(x), sy = Math.floor(y), fx = x - sx, fy = y - sy, a = (sy * warp.width + sx) * 2, b = (sy * warp.width + Math.min(sx + 1, warp.width - 1)) * 2, c = (Math.min(sy + 1, warp.height - 1) * warp.width + sx) * 2, d2 = (Math.min(sy + 1, warp.height - 1) * warp.width + Math.min(sx + 1, warp.width - 1)) * 2, w = [(1 - fx) * (1 - fy), fx * (1 - fy), (1 - fx) * fy, fx * fy];
    return [0, 1].map((k) => warp.data[a + k] * w[0] + warp.data[b + k] * w[1] + warp.data[c + k] * w[2] + warp.data[d2 + k] * w[3]);
  }
  var psdDetailWarpFields = /* @__PURE__ */ new Map();
  function psdDetailWarpField(url) {
    if (!psdDetailWarpFields.has(url)) psdDetailWarpFields.set(url, psdDetailImage(url).then((image) => decodePsdDetailWarp(psdDetailPixels(image, image.naturalWidth, image.naturalHeight))).catch((e) => {
      psdDetailWarpFields.delete(url);
      throw e;
    }));
    return psdDetailWarpFields.get(url);
  }
  var psdDetailImages = /* @__PURE__ */ new Map();
  var psdDetailManifests = /* @__PURE__ */ new Map();
  var psdDetailSources = /* @__PURE__ */ new Map();
  var psdDetailResults = /* @__PURE__ */ new Map();
  function psdDetailRemember(cache, key, value, limit) {
    cache.set(key, value);
    if (cache.size > limit) cache.delete(cache.keys().next().value);
    return value;
  }
  function psdDetailImage(url) {
    if (!psdDetailImages.has(url)) psdDetailRemember(psdDetailImages, url, new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = () => resolve(image);
      image.onerror = () => reject(Error("The detail image could not load."));
      image.src = url;
    }).catch((e) => {
      psdDetailImages.delete(url);
      throw e;
    }), 20);
    return psdDetailImages.get(url);
  }
  function psdDetailSurface(w, h = w) {
    return Object.assign(document.createElement("canvas"), { width: w, height: h });
  }
  function psdDetailPixels(image, w, h = w) {
    const c = psdDetailSurface(w, h), ctx = c.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(image, 0, 0, w, h);
    return ctx.getImageData(0, 0, w, h);
  }
  function psdDetailManifest(base, mm) {
    const url = new URL(mm[0] === mm[1] ? "laboo-tony-square-psd-20261026.json" : mm[0] > mm[1] ? "laboo-tony-horizontal-psd-20261026-v2.json" : "laboo-tony-portrait-paper-psd-20261025.json", new URL(base, "https://berahgewesjy.shop/")).href;
    if (!psdDetailManifests.has(url)) psdDetailManifests.set(url, fetch(url).then((r) => {
      if (!r.ok) throw Error("The detail template could not load.");
      return r.json();
    }).catch((e) => {
      psdDetailManifests.delete(url);
      throw e;
    }));
    return psdDetailManifests.get(url);
  }
  async function renderPsdDetail({ key, mm, artworkUrl, assetBase, size = 1e3 }) {
    if (!psdDetailEligible(key, mm)) throw Error("This Photoshop template does not match the print orientation.");
    const token = [key, mm.join("x"), artworkUrl, assetBase, size].join("|");
    if (psdDetailResults.has(token)) return psdDetailResults.get(token);
    const job = (async () => {
      const manifest = await psdDetailManifest(assetBase, mm), template = manifest.templates[key];
      if (!template) throw Error("Missing Photoshop template.");
      const base = new URL(template.base, new URL(assetBase, "https://berahgewesjy.shop/")).href, sourceKey = artworkUrl + "|" + mm.join("x");
      if (!psdDetailSources.has(sourceKey)) psdDetailRemember(psdDetailSources, sourceKey, psdDetailImage(artworkUrl).then((img) => psdDetailPixels(img, 1200, Math.round(1200 * mm[1] / mm[0]))), 3);
      const [photo, maskImage, art, warp] = await Promise.all([psdDetailImage(base), psdDetailImage(manifest.masks[template.mask]), psdDetailSources.get(sourceKey), template.warp ? psdDetailWarpField(manifest.warps[template.warp]) : null]), original = psdDetailPixels(photo, size), mask = psdDetailPixels(maskImage, size), c = psdDetailSurface(size), ctx = c.getContext("2d");
      ctx.putImageData(new ImageData(compositePsdDetail(art, original, mask, template, warp), size, size), 0, 0);
      return c.toDataURL("image/webp", 0.94);
    })().catch((e) => {
      psdDetailResults.delete(token);
      throw e;
    });
    return psdDetailRemember(psdDetailResults, token, job, 12);
  }

  // personalisation-product-integration/purchase-material-details.mjs
  var MATERIAL_FINISHES = { "natural-wood": "Natural wood", "dark-wood": "Dark wood", black: "Black", white: "White" };
  function purchaseMaterialOrientation(mm) {
    const [width, height] = Array.isArray(mm) ? mm : [];
    return width > 0 && height > 0 ? width > height ? "landscape" : width < height ? "portrait" : "square" : "";
  }
  function purchaseMaterialItems(finish = "none", mm) {
    const orientation = purchaseMaterialOrientation(mm), paper = { key: orientation === "square" ? "paper-square" : orientation === "landscape" ? "paper-landscape" : "paper", title: "200 gsm matte paper", note: "Smooth, heavyweight paper with a non-reflective finish. Paper detail illustration." };
    if (!MATERIAL_FINISHES[finish]) return [paper, { key: "flat-pack", title: "Flat-pack example", note: "Smaller prints are usually sent flat. Packaging is chosen for your print size and destination." }, { key: "tubes", title: "Tubes & triangular boxes", note: "Larger prints use protective tubes or triangular packaging. Packaging can vary by print size and destination." }];
    const label = MATERIAL_FINISHES[finish], items = [paper, { key: "frame-" + finish + (orientation === "square" ? "-square" : orientation === "landscape" ? "-landscape" : ""), title: label + " frame & Perspex", note: "Slim pine frame in " + label.toLowerCase() + " with clear protective Perspex glazing beneath the frame. Your personalised artwork is fitted inside. Frame detail illustration." }, { key: "backing-" + finish, title: "Backing & hanging kit", note: label + " frame, backing fitted and hanging kit included. Arrives assembled and ready to hang. Backing illustration; fittings may vary by size and production location." }];
    if (orientation === "portrait" || orientation === "landscape" || orientation === "square") items.push({ key: "pack-" + finish + "-" + orientation, title: "Packed ready to hang", note: "Your " + orientation + " print is fitted inside a " + label.toLowerCase() + " frame with clear Perspex glazing. Arrives assembled and ready to hang. Packaging illustration; carton and protection can vary by size and destination." });
    return items;
  }
  function purchaseMaterialUrl(base, key, thumbnail = false) {
    if (key === "paper-square" || /^(frame|pack)-(natural-wood|dark-wood|black|white)-square$/.test(key)) return new URL("laboo-tony-square-" + key + "-20261026-" + (thumbnail ? "thumb" : "base") + ".webp", new URL(base, "https://berahgewesjy.shop/")).href;
    if (key === "paper-landscape" || /^(frame|pack)-(natural-wood|dark-wood|black|white)-landscape$/.test(key)) return new URL("laboo-tony-horizontal-" + key + "-20261026-" + (thumbnail ? "thumb" : "base") + ".webp", new URL(base, "https://berahgewesjy.shop/")).href;
    return new URL("laboo-own-detail-" + (key === "paper" ? "paper-hand-v2" : key) + "-20261025" + (thumbnail ? "-thumb" : "") + ".webp", new URL(base, "https://berahgewesjy.shop/")).href;
  }
  function createPurchaseMaterialDetails({ host, dialog, assetBase, getSelection, isVisible }) {
    if (!host || !dialog || !assetBase) return { update() {
    } };
    const rail = document.createElement("section");
    rail.className = "laboo-purchase-materials";
    rail.hidden = true;
    rail.setAttribute("aria-label", "Paper, frame and packaging details");
    host.append(rail);
    const viewer = document.createElement("dialog");
    viewer.className = "laboo-material-viewer";
    viewer.setAttribute("aria-label", "Material and packaging details");
    viewer.innerHTML = '<header><strong data-material-title></strong><button type="button" data-material-close>Close \xD7</button></header><div class="laboo-material-view"><button type="button" data-material-prev aria-label="Previous detail"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></button><img data-material-image alt="" decoding="async"><span data-material-loading role="status" aria-live="polite">Loading detail\u2026</span><button type="button" data-material-next aria-label="Next detail"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg></button></div><p data-material-note></p><p class="laboo-material-counter" data-material-counter></p>';
    dialog.append(viewer);
    const image = viewer.querySelector("[data-material-image]"), loading = viewer.querySelector("[data-material-loading]");
    let items = [], key = "", index = 0, scheduled = false, showVersion = 0;
    const close = () => {
      showVersion++;
      if (viewer.open) viewer.close();
    };
    function detail(item, size) {
      const selection = getSelection() || {}, personalised = !!(psdDetailEligible(item.key, selection.mm) && selection.artworkUrl), url = purchaseMaterialUrl(assetBase, item.key, size === 320);
      if (!personalised) return Promise.resolve({ url, personalised: false });
      return renderPsdDetail({ key: item.key, mm: selection.mm, artworkUrl: selection.artworkUrl, assetBase, size }).then((url2) => ({ url: url2, personalised: true }));
    }
    async function show(next) {
      if (!items.length) return;
      index = (next + items.length) % items.length;
      const item = items[index];
      viewer.querySelector("[data-material-title]").textContent = item.title;
      viewer.querySelector("[data-material-note]").textContent = item.note;
      viewer.querySelector("[data-material-counter]").textContent = index + 1 + " of " + items.length;
      const version = ++showVersion;
      loading.hidden = false;
      loading.textContent = "Preparing your detail\u2026";
      image.hidden = true;
      image.alt = item.title + " \u2014 material detail";
      if (!viewer.open) viewer.showModal();
      try {
        const result = await detail(item, 1e3);
        if (version !== showVersion || !viewer.open) return;
        image.dataset.personalised = String(result.personalised);
        image.onload = () => {
          if (version !== showVersion) return;
          image.hidden = false;
          loading.hidden = true;
        };
        image.onerror = () => {
          if (version !== showVersion) return;
          image.hidden = true;
          loading.hidden = false;
          loading.textContent = "This detail image could not load. Close and try again.";
        };
        image.src = result.url;
      } catch {
        if (version === showVersion) {
          loading.hidden = false;
          loading.textContent = "Your personalised detail could not load. Close and try again.";
        }
      }
    }
    viewer.querySelector("[data-material-close]").addEventListener("click", close);
    viewer.querySelector("[data-material-prev]").addEventListener("click", () => show(index - 1));
    viewer.querySelector("[data-material-next]").addEventListener("click", () => show(index + 1));
    viewer.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        event.stopPropagation();
        show(index + (event.key === "ArrowLeft" ? -1 : 1));
      }
    });
    viewer.addEventListener("cancel", (event) => event.stopPropagation());
    dialog.addEventListener("close", close);
    function update() {
      const visible = !!isVisible();
      rail.hidden = !visible;
      if (host.classList.contains("laboo-has-purchase-materials") !== visible) host.classList.toggle("laboo-has-purchase-materials", visible);
      if (!visible) {
        close();
        return;
      }
      const selection = getSelection() || {}, finish = selection.finish || "none", orientation = purchaseMaterialOrientation(selection.mm), nextKey = [finish, orientation, selection.mm?.join("x"), selection.artworkUrl || ""].join("|");
      if (nextKey === key) return;
      const reopen = viewer.open, active = items[index]?.key;
      key = nextKey;
      showVersion++;
      items = purchaseMaterialItems(finish, selection.mm);
      rail.dataset.finish = finish;
      rail.dataset.orientation = orientation;
      rail.style.setProperty("--laboo-material-count", String(items.length));
      rail.replaceChildren();
      for (const [i, item] of items.entries()) {
        const button = document.createElement("button");
        button.type = "button";
        button.setAttribute("aria-label", "View " + item.title.toLowerCase());
        button.setAttribute("aria-haspopup", "dialog");
        button.dataset.materialKey = item.key;
        const photo = document.createElement("img");
        photo.alt = "";
        photo.loading = "lazy";
        photo.decoding = "async";
        photo.width = 320;
        photo.height = 240;
        photo.src = purchaseMaterialUrl(assetBase, item.key, true);
        const label = document.createElement("span");
        label.textContent = item.title;
        button.append(photo, label);
        button.addEventListener("click", () => show(i));
        rail.append(button);
        if (selection.artworkUrl && psdDetailEligible(item.key, selection.mm)) {
          const ownKey = key;
          setTimeout(() => {
            if (key !== ownKey || !photo.isConnected) return;
            void detail(item, 320).then((result) => {
              if (key === ownKey && photo.isConnected) {
                photo.src = result.url;
                photo.dataset.personalised = String(result.personalised);
              }
            }).catch(() => {
            });
          }, 0);
        }
      }
      if (reopen) void show(Math.max(0, items.findIndex((item) => item.key === active)));
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        update();
      });
    }
    new MutationObserver(schedule).observe(dialog, { subtree: true, attributes: true, attributeFilter: ["src", "data-phase", "data-pf-internal", "data-mobile-edit", "class", "open"] });
    dialog.addEventListener("change", schedule);
    dialog.addEventListener("laboo:finish-change", schedule);
    schedule();
    return { update };
  }

  // personalisation-product-integration/personalised-storefront.mjs
  var root = document.querySelector("[data-personalised-launch]");
  if (root) void initialiseGenericPersonaliser(root).catch((e) => {
    root.querySelector("[data-launch-status]").textContent = "Personalisation could not load. Please refresh this page.";
    console.error(e.message);
  });
  async function initialiseGenericPersonaliser(root2) {
    const launch = root2.querySelector("button"), api = root2.dataset.api, privateReview = root2.dataset.privateReview === "true", r = await fetch(root2.dataset.config);
    if (!r.ok) throw Error("CONFIG_UNAVAILABLE");
    const config = await r.json(), p = config.product, prices = JSON.parse(root2.querySelector("[data-variant-prices]").textContent);
    const dialog = document.createElement("dialog");
    dialog.className = "laboo-personalised-dialog lp-preview-first";
    dialog.setAttribute("aria-label", "Personalise " + p.title);
    dialog.innerHTML = `<header class="lp-header"><strong>Personalise your print</strong><button type="button" class="lp-close">Close \xD7</button></header><div class="lp-layout"><section class="lp-preview" aria-label="Your print preview"><div class="lp-stage"><canvas class="lp-mockup" width="1500" height="1500" role="img" aria-label="Your personalised print"></canvas><button type="button" class="lp-fullscreen">Full screen</button><button type="button" class="lp-leave-fullscreen" hidden>Back to editing</button></div><p class="lp-caption" aria-live="polite"></p><span class="lp-pinch">Pinch to zoom</span></section><section class="lp-editor"><nav class="lp-phases" aria-label="Personalisation steps"><button type="button" data-phase="personalise">Personalise</button><button type="button" data-phase="size">Size & frame</button><button type="button" data-phase="gift" hidden>Gift message</button><button type="button" data-phase="proof">Check</button></nav><p class="lp-progress"></p><h2 class="lp-step-title"></h2><div class="lp-fields"></div><section class="lp-size" hidden><label>Print size<select name="size"></select></label><label class="lp-country">Delivery country<select name="country"></select></label><details class="lp-size-guide" open><summary>See the size beside a person</summary><div data-size-guide></div></details></section><section class="lp-finishes" hidden><fieldset><legend>Frame</legend>${[["none", "Print only"], ["natural-wood", "Natural wood"], ["dark-wood", "Dark wood"], ["black", "Black"], ["white", "White"]].map(([v, l]) => `<label class="lp-finish"><input type="radio" name="lp_finish" value="${v}"${v === "none" ? " checked" : ""}><span class="lp-finish-icon" data-finish="${v}" aria-hidden="true"></span><span><strong>${l}</strong><small data-extra="${v}"></small></span></label>`).join("")}</fieldset><p class="lp-frame-note" aria-live="polite"></p></section><div class="lp-gift" hidden><button type="button" class="lp-skip-gift">Continue without a message</button></div><details class="lp-sky" hidden><summary>Sky chart details and credits</summary><p>Calculated for your location, local date and time. North at top, east at left; stars above the horizon to magnitude 6. HYG v4.1, Astronexus, CC BY-SA 4.0. Constellations: Stellarium Modern / Sky & Telescope, CC BY-SA 2.0. Chart adaptation: CC BY-SA 4.0.</p></details></section><section class="lp-proof" hidden></section></div><footer class="lp-footer"><div class="lp-order"><span class="lp-order-label"></span><strong class="lp-price"></strong></div><div class="lp-actions"><button type="button" data-back>&#8592; Back</button><button type="button" class="lp-primary" data-next>Next</button><button type="button" class="lp-primary" data-add hidden>Add to basket</button></div><p class="lp-error" role="status" aria-live="polite"></p></footer>`;
    document.body.append(dialog);
    const $ = (s) => dialog.querySelector(s), country = $("[name=country]"), size = $("[name=size]"), fieldHost = $(".lp-fields"), mobile = () => matchMedia("(max-width:767px)").matches;
    let steps = genericSteps(p), index = 0, resources, skyData, A, version = 0, blob, saveAttempt, busy = false, adding = false, locationConfirmed = !hasGenericLocation(p), giftUI = null, proof = null, lastProofSelection = null;
    const inputs = /* @__PURE__ */ new Map(), wraps = /* @__PURE__ */ new Map(), defaults = { ...p.defaults }, money = (n) => new Intl.NumberFormat("en-GB", { style: "currency", currency: root2.dataset.currency || "GBP" }).format(n / 100);
    if (p.fields.some((f) => f.key === "palette")) defaults.palette = "original";
    if (p.handle === "custom-star-map") {
      defaults.timeZone ||= "America/New_York";
      if (!p.fields.some((f) => f.key === "timeZone")) p.fields.push({ key: "timeZone", label: "Time zone", type: "timezone", optional: true, value: defaults.timeZone });
    }
    for (const f of p.fields) {
      if (f.key === "palette" && f.type === "select") {
        const swatches = createPaletteSwatches({ document, handle: p.handle, name: f.key, label: f.label, value: defaults.palette });
        swatches.input.required = !f.optional;
        fieldHost.append(swatches.element);
        inputs.set(f.key, swatches.input);
        wraps.set(f.key, swatches.element);
        continue;
      }
      const label = document.createElement("label");
      label.className = "lp-field";
      label.dataset.field = f.key;
      const fieldLabel = document.createElement("span");
      fieldLabel.className = "lp-field-label";
      fieldLabel.textContent = f.label + (f.optional ? " (optional)" : "");
      label.append(fieldLabel);
      let input;
      if (f.type === "select") {
        input = document.createElement("select");
        for (const [v, l] of f.options) input.add(new Option(l, v));
      } else if (f.type === "lines") {
        input = document.createElement("textarea");
        input.rows = 3;
      } else {
        input = document.createElement("input");
        input.type = ["date", "time"].includes(f.type) ? f.type : ["latitude", "longitude", "offset"].includes(f.type) ? "number" : "text";
        if (f.max) input.maxLength = f.max;
        if (input.type === "number") input.step = f.type === "offset" ? ".25" : "any";
      }
      if (f.type === "year") {
        input.inputMode = "numeric";
        input.maxLength = 4;
        input.pattern = "(19|20)[0-9]{2}";
      }
      if (f.type === "date") {
        input.min = "1900-01-01";
        input.max = "2100-12-31";
      }
      input.name = f.key;
      if (f.key === "time") input.setAttribute("aria-label", f.label);
      input.value = defaults[f.key] ?? "";
      input.required = !f.optional;
      label.append(input);
      fieldHost.append(label);
      inputs.set(f.key, input);
      wraps.set(f.key, label);
    }
    const region = new Intl.DisplayNames(["en"], { type: "region" });
    for (const code of PRINT_COUNTRIES) country.add(new Option(region.of(code), code));
    country.value = PRINT_COUNTRIES.includes(root2.dataset.country) ? root2.dataset.country : "GB";
    for (const v of p.variants) size.add(new Option(v.title, v.id));
    const requested = new URL(location.href).searchParams.get("variant"), requestedFrame = Object.values(config.purchases || {}).find((f) => f.purchaseVariantId === requested);
    if (p.variants.some((v) => v.id === requested)) size.value = requested;
    else if (requestedFrame) size.value = requestedFrame.sourceVariantId;
    let finish = requestedFrame?.finish || "none";
    const guide = createSelectedSizeGuide($("[data-size-guide]"));
    $("[data-size-guide] .laboo-scale-guide-note").textContent = "Illustrative comparison. Measurements are for the print; any frame shown is for scale.";
    const mockup = createCleanFrameMockup($(".lp-mockup"), root2.dataset.overlay, { frameLabel: "selected order finish" }), fields = () => Object.fromEntries(p.fields.map((f) => [f.key, inputs.get(f.key).value]));
    const getOffer = (source, choice) => {
      if (!choice || choice === "none" || p.frameCheckoutPending) return null;
      try {
        const o = lookupFramePurchase(source, choice, country.value, config.purchases || {}), actual = prices[o.purchaseVariantId], print = prices[source];
        return Number.isInteger(actual) && Number.isInteger(print) && actual >= print ? { ...o, pricePence: actual, upgradePence: actual - print } : null;
      } catch {
        return null;
      }
    };
    const selected = () => {
      const v = p.variants.find((v2) => v2.id === size.value);
      return { v, print: printProduct(v, country.value), offer: getOffer(v.id, finish) };
    }, artworkKey = () => JSON.stringify({ fields: fields(), variantId: size.value, country: country.value, finish }), proofKey = () => JSON.stringify([artworkKey(), giftUI?.getGiftKey() || null]);
    const materialDetails = createPurchaseMaterialDetails({ host: $(".lp-stage"), dialog, assetBase: root2.dataset.overlay, getSelection: () => ({ finish, mm: selected().print.mm, artworkUrl: blob }), isVisible: () => dialog.open && dialog.dataset.phase === "size" && !dialog.classList.contains("lp-fullscreen-open") });
    const post = async (route, body) => {
      const r2 = await fetch(api + "/" + route, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), signal: AbortSignal.timeout(6e4) }), d2 = await r2.json();
      if (!r2.ok) throw Error(d2.error || "Your print could not be prepared.");
      return d2;
    };
    let locationHost = null, locationAutocomplete = null, searchStatus = null, foldHost = null, foldChoice = null, foldKey = null;
    if (p.handle === "custom-star-map") {
      foldHost = document.createElement("div");
      foldHost.hidden = true;
      foldHost.textContent = "The clocks change at this time. Choose which occurrence.";
      foldChoice = document.createElement("select");
      foldChoice.setAttribute("aria-label", "Time occurrence");
      foldHost.append(foldChoice);
      wraps.get("time").append(foldHost);
    }
    if (hasGenericLocation(p)) {
      locationHost = document.createElement("div");
      locationHost.className = "lp-location";
      locationHost.innerHTML = '<label>Find your place<input type="search" data-location-query placeholder="Start typing an address" autocomplete="off"></label><button type="button" data-location-search>Find place</button><div data-location-results></div><p data-location-status role="status"></p>';
      const label = wraps.get("location");
      label.before(locationHost);
      locationHost.append(label);
      searchStatus = locationHost.querySelector("[data-location-status]");
      const queryInput = locationHost.querySelector("[data-location-query]");
      locationAutocomplete = createPlaceAutocomplete({ input: queryInput, getCountry: () => country.value, button: locationHost.querySelector("[data-location-search]"), results: locationHost.querySelector("[data-location-results]"), status: searchStatus, search: async (query) => (await post("map-search", { template: p.template, query })).results, onSelect: (hit) => {
        if (inputs.has("timeZone") && !hit.timeZone) {
          searchStatus.textContent = "A time zone could not be verified for this place. Please choose another match.";
          return false;
        }
        inputs.get("location").value = hit.city ? hit.city + (hit.country ? ", " + hit.country : "") : hit.label;
        inputs.get("latitude").value = hit.latitude;
        inputs.get("longitude").value = hit.longitude;
        if (inputs.has("timeZone")) inputs.get("timeZone").value = hit.timeZone;
        locationConfirmed = true;
        changed();
        return true;
      } });
      queryInput.addEventListener("input", (event) => {
        event.stopPropagation();
        locationConfirmed = false;
        invalidate();
      });
    }
    let proofCountry = country.value;
    const createProof = () => createFinalProofPanel($(".lp-proof"), { prepareProof, rendererUrl: root2.dataset.pdf, workerUrl: root2.dataset.pdfWorker, country: country.value, personalisationType: "personalised", mobileApprovalPrompt: true, isActive: () => steps[index]?.kind === "proof", onChange: updateButtons });
    proof = createProof();
    function invalidate() {
      version++;
      lastProofSelection = null;
      saveAttempt = null;
      proof.invalidate();
      updateButtons();
    }
    function timezone() {
      if (p.handle !== "custom-star-map") return;
      const data = fields();
      if (!data.timeZone) return;
      const choices = localTimeOffsets(data);
      if (!choices.length) throw Error("This local time is unavailable or its historical offset cannot be verified. Please choose another time.");
      if (choices.length === 1) {
        inputs.get("utcOffset").value = String(choices[0].offset);
        foldHost.hidden = true;
        foldKey = null;
      } else {
        const key = JSON.stringify([data.date, data.time, data.timeZone]);
        if (key !== foldKey) {
          foldKey = key;
          foldChoice.replaceChildren(new Option("Choose the time shown on the clock", ""), ...choices.map((c, i) => new Option((i === 0 ? "First" : "Second") + " occurrence \xB7 UTC" + (c.offset >= 0 ? "+" : "") + c.offset, String(c.offset))));
        }
        foldHost.hidden = false;
        if (foldChoice.value === "") throw Error("This time occurs twice because the clocks change. Choose the first or second occurrence.");
        inputs.get("utcOffset").value = foldChoice.value;
      }
    }
    function options() {
      locationAutocomplete?.refreshCopy();
      let { v, print } = selected();
      if (!print.available) {
        size.value = p.variants.find((model) => printProduct(model, country.value).available)?.id;
        ({ v, print } = selected());
      }
      if (finish !== "none" && !getOffer(v.id, finish)) finish = "none";
      for (const option of size.options) {
        const model = p.variants.find((v2) => v2.id === option.value);
        option.disabled = !printProduct(model, country.value).available;
        const offer2 = getOffer(model.id, finish);
        option.textContent = model.title + " \xB7 " + money(prices[offer2?.purchaseVariantId || model.id]);
      }
      const offer = getOffer(v.id, finish), price = prices[offer?.purchaseVariantId || v.id];
      if (!Number.isInteger(price)) throw Error("The selected price is unavailable. Please refresh.");
      for (const input of dialog.querySelectorAll("[name=lp_finish]")) {
        const o = getOffer(v.id, input.value);
        input.disabled = input.value !== "none" && !o;
        input.checked = input.value === finish;
        $(`[data-extra="${input.value}"]`).textContent = input.value === "none" ? "No frame" : o ? "+" + money(o.upgradePence) + " \xB7 Ready to hang" : "Currently unavailable";
      }
      const label = { "natural-wood": "Natural wood", "dark-wood": "Dark wood", black: "Black", white: "White" }[finish];
      $(".lp-frame-note").textContent = finish === "none" ? "You will receive an unframed paper print. No frame is included." : "Your print is fitted in a " + label.toLowerCase() + " frame with clear Perspex glazing. Arrives assembled and ready to hang.";
      $(".lp-price").textContent = money(price);
      $(".lp-order-label").textContent = print.label + " \xB7 " + (label || "Print only");
      dialog.dataset.purchaseFinish = finish;
      const unit = country.value === "US" ? "in" : "cm", dimensions = print.mm.map((n) => Number((n / (unit === "in" ? 25.4 : 10)).toFixed(2)) + " " + unit);
      guide.update({ mm: print.mm, label: print.label, widthText: dimensions[0], heightText: dimensions[1], personLabel: unit === "in" ? "Person: 5 ft 10 in" : "Person: 178 cm", country: country.value, unit }, finish);
    }
    async function scene() {
      resources ||= await fetch(config.resources).then((r2) => {
        if (!r2.ok) throw Error("Artwork resources could not load.");
        return r2.json();
      });
      timezone();
      const values = normaliseFields(p.handle, fields());
      let sky = null;
      if (p.handle === "custom-star-map") {
        if (!skyData) [skyData, A] = await Promise.all([fetch(config.skyData).then((r2) => r2.json()), import(config.astronomy)]);
        const { buildSky: buildSky2 } = await Promise.resolve().then(() => (init_personalised_sky(), personalised_sky_exports));
        sky = buildSky2(values, skyData, A);
      }
      return buildPersonalisedScene(p, values, selected().print.mm, resources, { sky });
    }
    async function preview() {
      const current = ++version;
      try {
        let svg;
        if (isGenericMap(p)) {
          const r2 = await fetch(api + "/preview", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ template: p.template, variantId: size.value, country: country.value, finish, purchaseVariantId: selected().offer?.purchaseVariantId || size.value, fields: normaliseFields(p.handle, fields()) }), signal: AbortSignal.timeout(6e4) });
          if (!r2.ok) {
            const d2 = await r2.json();
            throw Error(d2.error || "Map preview unavailable.");
          }
          svg = await r2.text();
        } else svg = personalisedSVG(await scene());
        if (current !== version) return;
        const url = URL.createObjectURL(new Blob([svg], { type: "image/svg+xml" })), old = blob;
        blob = url;
        await mockup(url, selected().print.mm, finish);
        if (current !== version) return;
        if (old) URL.revokeObjectURL(old);
        guide.setArtwork(url);
        materialDetails.update();
        $(".lp-caption").textContent = selected().print.label + " \xB7 " + (finish === "none" ? "Print only" : { "natural-wood": "Natural wood", "dark-wood": "Dark wood", black: "Black", white: "White" }[finish] + " frame");
        $(".lp-error").textContent = "";
      } catch (e) {
        if (current === version) $(".lp-error").textContent = e.message;
      } finally {
        updateButtons();
      }
    }
    function changed() {
      if (country.value !== proofCountry) {
        proof.invalidate();
        proofCountry = country.value;
        proof = createProof();
      }
      invalidate();
      try {
        options();
      } catch (e) {
        $(".lp-error").textContent = e.message;
      }
      void preview();
    }
    function fitProof() {
      const canvas = $(".lp-proof [data-final-proof-image]"), stage = $(".lp-proof .laboo-final-proof-image"), sheet = $(".lp-proof .laboo-proof-trim-sheet");
      if (!canvas || canvas.hidden || !canvas.width || !stage.clientHeight) return;
      const css = getComputedStyle(stage), w = stage.clientWidth - parseFloat(css.paddingLeft) - parseFloat(css.paddingRight), h = stage.clientHeight - parseFloat(css.paddingTop) - parseFloat(css.paddingBottom), scale = Math.min(w / canvas.width, h / canvas.height);
      if (scale <= 0) return;
      sheet.style.width = canvas.width * scale + "px";
      sheet.style.height = canvas.height * scale + "px";
      canvas.style.width = "100%";
      canvas.style.height = "100%";
    }
    function updateButtons() {
      if (!dialog.isConnected) return;
      const final = steps[index]?.kind === "proof";
      $("[data-add]").hidden = !final;
      $("[data-next]").hidden = final;
      $("[data-add]").disabled = adding || busy || !proof?.isReady?.();
      $("[data-next]").disabled = busy;
      $("[data-back]").disabled = index === 0 || adding;
      if (proof?.isReady?.()) fitProof();
    }
    function show() {
      const s = steps[index], phase = genericStage(s), final = s.kind === "proof";
      $("[data-phase=gift]").hidden = !giftUI?.isEnabled();
      dialog.dataset.phase = phase;
      dialog.classList.toggle("lp-is-proof", final);
      $(".lp-preview").hidden = $(".lp-editor").hidden = final;
      $(".lp-proof").hidden = !final;
      const guidePanel = $(".lp-size-guide");
      if (mobile()) $(".lp-size").append(guidePanel);
      else $(".lp-finishes").after(guidePanel);
      guidePanel.hidden = mobile() ? s.kind !== "size" : phase !== "size";
      $(".lp-progress").textContent = index + 1 + " of " + steps.length;
      $(".lp-step-title").textContent = s.title;
      for (const [key, label] of wraps) {
        const derived = ["latitude", "longitude", "utcOffset", "timeZone"].includes(key) && hasGenericLocation(p);
        label.hidden = derived || mobile() && !s.keys.includes(key) || !mobile() && phase !== "personalise";
      }
      if (locationHost) locationHost.hidden = mobile() ? s.kind !== "location" : phase !== "personalise";
      $(".lp-fields").hidden = phase !== "personalise";
      $(".lp-size").hidden = mobile() ? s.kind !== "size" : phase !== "size";
      $(".lp-finishes").hidden = mobile() ? s.kind !== "frame" : phase !== "size";
      $(".lp-gift").hidden = phase !== "gift" || !giftUI?.isEnabled();
      if (giftUI) {
        giftUI.choice.hidden = mobile() && !!s.giftField;
        for (const part of giftUI.fields.querySelectorAll("[data-gift-part]")) part.hidden = mobile() && part.dataset.giftPart !== s.giftField;
        $(".lp-skip-gift").hidden = phase !== "gift";
      }
      $(".lp-sky").hidden = p.handle !== "custom-star-map" || phase !== "personalise";
      for (const b of dialog.querySelectorAll("[data-phase]")) b.setAttribute("aria-current", String(b.dataset.phase === phase));
      $("[data-next]").textContent = (mobile() ? steps[index + 1]?.kind === "proof" : phaseSequence()[phaseSequence().indexOf(phase) + 1] === "proof") ? "Check your print \u2192" : "Next \u2192";
      updateButtons();
    }
    function validateCurrent() {
      const s = steps[index];
      if (s.kind === "gift" && s.giftField && !giftUI.validate(s.giftField)) return false;
      if (s.kind === "location" && !locationConfirmed) {
        searchStatus.textContent = "Type your place and choose a matching suggestion.";
        locationHost.querySelector("[data-location-query]").focus();
        return false;
      }
      for (const key of s.keys) {
        const input = inputs.get(key);
        if (input && !input.checkValidity()) {
          input.setAttribute("aria-invalid", "true");
          input.reportValidity();
          input.focus();
          return false;
        }
      }
      normaliseFields(p.handle, { ...defaults, ...Object.fromEntries(s.keys.map((key) => [key, inputs.get(key).value])) });
      if (s.id === "time") timezone();
      return true;
    }
    async function go(n) {
      if (busy || adding || n < 0 || n >= steps.length) return;
      try {
        const final = steps[n]?.kind === "proof";
        if (n > index && !validateCurrent()) return;
        if (final) {
          if (hasGenericLocation(p) && !locationConfirmed) throw Error("Please confirm the map location before checking your print.");
          timezone();
          normaliseFields(p.handle, fields());
          if (giftUI && !giftUI.validate()) {
            const bad = giftUI.inputs.find((el) => el.getAttribute("aria-invalid") === "true");
            index = Math.max(0, steps.findIndex((s) => mobile() ? s.giftField === bad?.dataset.gift : s.id === "gift"));
            show();
            bad?.focus({ preventScroll: true });
            return;
          }
        }
        index = n;
        show();
        $(".lp-editor").scrollTop = 0;
        $(".laboo-final-proof-details").scrollTop = 0;
        $(".lp-error").textContent = "";
        if (final && (lastProofSelection !== proofKey() || !proof.isReady())) await proof.prepare();
      } catch (e) {
        $(".lp-error").textContent = e.message;
      } finally {
        updateButtons();
      }
    }
    async function prepareProof() {
      busy = true;
      updateButtons();
      try {
        const selection = proofKey();
        if (saveAttempt?.key !== selection) saveAttempt = { key: selection, id: crypto.randomUUID() };
        const { offer } = selected();
        const result = await post("save", { template: p.template, revision: 9, variantId: size.value, country: country.value, finish, purchaseVariantId: offer?.purchaseVariantId || size.value, fields: fields(), requestId: saveAttempt.id, gift: giftUI?.getGift() || null });
        if (result.engine !== "personalised-v1" || result.previewOnly && !privateReview) throw Error("Checkout is temporarily unavailable.");
        if (selection !== proofKey()) throw Error("Your design changed. Please prepare your proof again.");
        lastProofSelection = selection;
        return { ...result, personalisationType: "personalised", personalisationSummary: genericSummary(p, result.fields || fields()) };
      } finally {
        busy = false;
        updateButtons();
      }
    }
    $("[data-add]").onclick = async () => {
      if (adding || busy || !proof.isReady()) return;
      if (!proof.validate()) return;
      const saved = proof.getProof();
      if (lastProofSelection !== proofKey()) {
        proof.invalidate();
        $(".lp-error").textContent = "Your design changed. Please check a fresh proof.";
        return;
      }
      if (privateReview) {
        $(".lp-error").textContent = "Private review complete. Checkout is disabled and no order has been placed.";
        return;
      }
      adding = true;
      updateButtons();
      try {
        const approval = await post("approve", { ticketToken: new URL(saved.customerProofUrl).pathname.split("/").at(-1), sha256: saved.sha256, confirmed: true });
        if (!approval.approved || approval.sha256 !== saved.sha256) throw Error("Your proof approval could not be recorded.");
        const properties = Object.fromEntries(saved.orderProperties.map((f) => [f.name, f.value]));
        Object.assign(properties, { "Print size": saved.size, _Laboo_Design_ID: saved.designId, _Laboo_Proof_URL: saved.customerProofUrl, _Laboo_Preview_URL: saved.cartPreviewUrl || saved.previewUrl, _Laboo_Proof_System: "personalised-v1", _Laboo_Proof_Stage: "before_checkout" });
        if (saved.purchaseVariantId) Object.assign(properties, { Frame: saved.frameLabel, Assembly: "Ready to hang" });
        if (saved.gift) Object.assign(properties, giftOrderProperties(saved.gift));
        const route = window.Shopify?.routes?.root || "/", r2 = await (window.labooCartRequest || fetch)(route + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: saved.purchaseVariantId || saved.variantId, quantity: 1, properties }] }) }), data = typeof r2.json === "function" ? await r2.json() : r2;
        if (r2.ok === false || data.status >= 400) throw Error(data.description || "Your print could not be added.");
        if (!await showPersonalisedSideCart($(".lp-proof"), data)) location.assign(route + "cart");
      } catch (e) {
        $(".lp-error").textContent = e.message;
      } finally {
        adding = false;
        updateButtons();
      }
    };
    fieldHost.addEventListener("input", (e) => {
      e.target.removeAttribute("aria-invalid");
      changed();
    });
    country.onchange = size.onchange = changed;
    $(".lp-finishes").addEventListener("change", (e) => {
      if (e.target.name === "lp_finish") {
        finish = e.target.value;
        changed();
      }
    });
    $("[data-back]").onclick = () => void go(mobile() ? index - 1 : Math.max(0, steps.findIndex((s) => genericStage(s) === (phaseSequence()[phaseSequence().indexOf(genericStage(steps[index])) - 1] || "personalise"))));
    $("[data-next]").onclick = () => void go(mobile() ? index + 1 : steps.findIndex((s) => genericStage(s) === (phaseSequence()[phaseSequence().indexOf(genericStage(steps[index])) + 1] || "proof")));
    for (const b of dialog.querySelectorAll("[data-phase]")) b.onclick = () => void go(steps.findIndex((s) => genericStage(s) === b.dataset.phase));
    $(".lp-close").onclick = () => dialog.close();
    $(".lp-fullscreen").onclick = () => {
      dialog.classList.add("lp-fullscreen-open");
      $(".lp-leave-fullscreen").hidden = false;
    };
    $(".lp-leave-fullscreen").onclick = () => {
      dialog.classList.remove("lp-fullscreen-open");
      $(".lp-leave-fullscreen").hidden = true;
    };
    root2.closest("form")?.addEventListener("submit", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      launch.click();
    }, true);
    let bodyOverflow = "";
    dialog.addEventListener("close", () => {
      document.body.style.overflow = bodyOverflow;
    });
    window.addEventListener("resize", show);
    new ResizeObserver(fitProof).observe($(".lp-layout"));
    launch.disabled = false;
    launch.onclick = () => {
      bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      dialog.showModal();
      options();
      show();
      void preview();
    };
    root2.querySelector("[data-launch-status]").textContent = "";
    options();
    show();
    function phaseSequence() {
      return ["personalise", "size", ...giftUI?.isEnabled() ? ["gift"] : [], "proof"];
    }
    function rebuildGiftSteps() {
      const current = steps[index]?.id;
      steps = genericSteps(p, { giftEnabled: giftUI?.isEnabled(), giftSelected: giftUI?.isSelected() });
      index = Math.max(0, steps.findIndex((s) => s.id === current));
      show();
    }
    $(".lp-skip-gift").onclick = () => {
      const toggle = giftUI.section.querySelector("[data-gift-enabled]");
      toggle.checked = false;
      toggle.dispatchEvent(new Event("change", { bubbles: true }));
      void go(steps.findIndex((s) => s.kind === "proof"));
    };
    if (root2.dataset.giftConfig === "true") giftUI = createGiftMessage($(".lp-gift"), { productId: p.productId, api, onChange: () => {
      invalidate();
      rebuildGiftSteps();
    }, onAvailability: rebuildGiftSteps });
    if (giftUI) for (const label of giftUI.fields.querySelectorAll("label")) label.classList.add("lp-gift-field-label");
    return { dialog, product: p, steps: () => steps };
  }
})();
